function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("jO6eK", function(module, exports) {
    $parcel$export(module.exports, "ProfileCard", ()=>$26be85135f3bfa4d$export$bed540ccfa8743c4);
    $parcel$export(module.exports, "ProfileCardLegacy", ()=>$26be85135f3bfa4d$export$dd0591e04a6e8ce6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $pa9q9;
    var $aWse0;
    var $iXVV6;
    var $8zOmE;
    var $5y0F0;
    var $6SC3U;
    var $7hILA;
    var $kKeZ6;
    var $irubU;
    const $26be85135f3bfa4d$export$bed540ccfa8743c4 = (props)=>{
        const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData } = props;
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: (0, $e6a2e0952e4731b8$export$81319ffa9c0d18d7),
            attributes: analyticsData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7hILA")).default), {
            TenantContextSubscriber: TenantContextSubscriberComponent,
            externalProfileClient: externalProfileClient,
            analyticsData: analyticsData
        }, (atlassianAccountId, profileClient, cloudId, baseUrl)=>{
            if (atlassianAccountId !== '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5y0F0")).RouterActions), null, ({ push: push })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKeZ6")).default), {
                    profileClient: profileClient,
                    cloudId: cloudId,
                    accountId: accountId,
                    actions: (0, (0, parcelRequire("irubU")).getSpaActions)(accountId, baseUrl, intl, push, actions),
                    position: position,
                    onProfileClick: (profileAccountId)=>push(`${baseUrl}/jira/people/${profileAccountId}`),
                    addFlag: showFlag,
                    dismissFlag: dismissFlag,
                    testId: testId,
                    trigger: trigger,
                    prepopulatedData: prepopulatedData,
                    viewingUserId: atlassianAccountId || undefined
                }, children));
            return children;
        }));
    };
    const $26be85135f3bfa4d$export$dd0591e04a6e8ce6 = (props)=>{
        const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, actions: actions } = props;
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const onLoadError = (error, analyticsEvent)=>{
            if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${analyticsEvent.payload.actionSubject} ${analyticsEvent.payload.action}`, `${analyticsEvent.payload.actionSubject}${analyticsEvent.payload.action}`, {
                error: error
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: (0, $e6a2e0952e4731b8$export$50632e21ea714398)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7hILA")).default), {
            TenantContextSubscriber: TenantContextSubscriberComponent,
            externalProfileClient: externalProfileClient,
            onLoadError: onLoadError
        }, (atlassianAccountId, profileClient, cloudId, baseUrl)=>atlassianAccountId !== null ? (0, ($parcel$interopDefault($5uXOq))).createElement($26be85135f3bfa4d$var$LegacyProfileCardStyled, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5y0F0")).RouterActions), null, ({ push: push })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SC3U")).default), {
                    profileClient: profileClient,
                    cloudId: cloudId,
                    baseUrl: baseUrl,
                    onGetActions: (accountId, onActionCleanup)=>(0, (0, parcelRequire("irubU")).getSpaActions)(accountId, baseUrl, intl, push, actions, onActionCleanup),
                    onProfileClick: (profileAccountId)=>push(`${baseUrl}/jira/people/${profileAccountId}`)
                }))) : null));
    };
    const $26be85135f3bfa4d$var$LegacyProfileCardStyled = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1pbyb4wl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aWse0", function(module, exports) {
    $parcel$export(module.exports, "useIntlV2", ()=>$6b28e3c9e1c89fbd$export$d82607073b68786);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
        const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, (0, parcelRequire("koVbs")).default)();
        const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
            const modifiedIntl = {
                messages: messages,
                locale: locale,
                formats: formats,
                formatDate: formatDate,
                formatMessage: formatMessage,
                formatNumber: formatNumber,
                formatPlural: formatPlural,
                formatTime: formatTime
            };
            return modifiedIntl;
        }, [
            formatDate,
            formatMessage,
            formatPlural,
            formatTime,
            formatNumber,
            formats,
            locale,
            messages
        ]);
        return memoisedIntl;
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
const $e6a2e0952e4731b8$export$febebefae5a09065 = 'profile-card.loaded';
const $e6a2e0952e4731b8$export$3ca1936ee743bd18 = 'profile-card.view';
const $e6a2e0952e4731b8$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $e6a2e0952e4731b8$export$86aa8b9c379ebbbd = 'profile-card.error';
const $e6a2e0952e4731b8$export$4442e31da6ba4127 = 'profile-card.click';
const $e6a2e0952e4731b8$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';
parcelRegister("6SC3U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$041ceaf6ad56ccb8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    parcelRequire("26CR2");
    var $iMLpJ = parcelRequire("iMLpJ");
    var $2OMDV;
    var $ih2j7;
    var $t1z25;
    var $8L4jp;
    var $8cFNQ;
    const $041ceaf6ad56ccb8$var$AnalyticsWrapper = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)((0, $03bf38ed90f474bb$export$a1455360a24a2234), {
        onAnalytics: 'fired'
    });
    const $041ceaf6ad56ccb8$export$23f88898e1cb6da9 = $041ceaf6ad56ccb8$var$AnalyticsWrapper((0, $iMLpJ.default)((0, (0, parcelRequire("8cFNQ")).default)));
    const $041ceaf6ad56ccb8$var$eventListenerOptions = {
        passive: true
    };
    const $041ceaf6ad56ccb8$export$dd0591e04a6e8ce6 = ({ baseUrl: baseUrl, profileClient: profileClient, cloudId: cloudId, onGetActions: onGetActions, onProfileClick: onProfileClick })=>{
        (0, (0, parcelRequire("gKZoD")).di)(setTimeout);
        const [userData, setUserData] = (0, $5uXOq.useState)(null);
        const [referenceElement, setReferenceElement] = (0, $5uXOq.useState)(null);
        const [showProfileCard, setShowProfileCard] = (0, $5uXOq.useState)(false);
        const [offset, setOffset] = (0, $5uXOq.useState)(null);
        const showTimeoutId = (0, $5uXOq.useRef)(null);
        const onMouseLeaveCancelShowCard = ()=>{
            if (showTimeoutId.current) clearTimeout(showTimeoutId.current);
        };
        const onHideProfileCard = ()=>{
            setShowProfileCard(false);
            onMouseLeaveCancelShowCard();
        };
        const { setTriggerRef: setTriggerRef, setCardRef: setCardRef, unsetTriggerRef: unsetTriggerRef, unsetCardRef: unsetCardRef, getTimeoutId: getTimeoutId } = (0, (0, parcelRequire("t1z25")).useHideProfileCardDelayed)(true, false, onHideProfileCard);
        (0, (0, parcelRequire("t1z25")).useEventListener)('mouseleave', unsetTriggerRef, referenceElement, $041ceaf6ad56ccb8$var$eventListenerOptions);
        (0, (0, parcelRequire("t1z25")).useEventListener)('mouseleave', onMouseLeaveCancelShowCard, referenceElement, $041ceaf6ad56ccb8$var$eventListenerOptions);
        (0, (0, parcelRequire("t1z25")).useEventListener)('mouseenter', setTriggerRef, referenceElement, $041ceaf6ad56ccb8$var$eventListenerOptions);
        (0, (0, parcelRequire("t1z25")).useEventListener)('scroll', onHideProfileCard, window, $041ceaf6ad56ccb8$var$eventListenerOptions);
        const clearHideCardTimeout = (timeoutId)=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
        const setShowProfileCardDelayed = ()=>setTimeout(()=>setShowProfileCard(true), (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3));
        const setData = (data, ref, offsetValue)=>{
            clearHideCardTimeout(getTimeoutId());
            setOffset(offsetValue || '0, 8px');
            setUserData(data);
            setReferenceElement(ref);
            showTimeoutId.current = setShowProfileCardDelayed();
        };
        const api = {
            setData: setData,
            hideProfileCard: onHideProfileCard
        };
        (0, (0, parcelRequire("8L4jp")).default)(api);
        return showProfileCard && referenceElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ih2j7")).ProfileCardLegacyWrapper), {
            onMouseEnter: setCardRef,
            onMouseLeave: unsetCardRef,
            referenceElement: referenceElement,
            offset: offset
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($041ceaf6ad56ccb8$export$23f88898e1cb6da9, {
                baseUrl: baseUrl,
                accountId: userData && userData.accountId,
                cloudId: cloudId,
                handleEscapeKeydown: onHideProfileCard,
                handleClickOutside: onHideProfileCard,
                profileClient: profileClient,
                actions: onGetActions(userData ? userData.accountId : '', ()=>{
                    clearHideCardTimeout(getTimeoutId());
                    onHideProfileCard();
                }),
                onProfileClick: onProfileClick
            }));
    };
    var $041ceaf6ad56ccb8$export$2e2bcd8739ae039 = $041ceaf6ad56ccb8$export$dd0591e04a6e8ce6;
});
parcelRegister("26CR2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b61766090747c00e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "withOuterListeners", ()=>(parcelRequire("iMLpJ")).default);
    $parcel$export(module.exports, "TeamProfileCard", ()=>(parcelRequire("AF8aN")).default);
    $parcel$export(module.exports, "ProfileCardTrigger", ()=>(parcelRequire("264zF")).default);
    $parcel$export(module.exports, "ProfileClient", ()=>(parcelRequire("bp5g1")).default);
    $parcel$export(module.exports, "UserProfileClient", ()=>(parcelRequire("dFLsP")).default);
    $parcel$export(module.exports, "DELAY_MS_SHOW", ()=>$e41878b3b8cab0db$export$5b956b542f1bc1b3);
    $parcel$export(module.exports, "AgentProfileCardTrigger", ()=>(parcelRequire("5uVl7")).AgentProfileCardTrigger);
    var $bp5g1 = parcelRequire("bp5g1");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    var $9gV7o = parcelRequire("9gV7o");
    var $6uTwi = parcelRequire("6uTwi");
    var $lrMir = parcelRequire("lrMir");
    var $d4FHw = parcelRequire("d4FHw");
    var $264zF = parcelRequire("264zF");
    var $iMLpJ = parcelRequire("iMLpJ");
    var $AF8aN = parcelRequire("AF8aN");
    var $5uVl7 = parcelRequire("5uVl7");
    var $kDbj5 = parcelRequire("kDbj5");
    var $b61766090747c00e$export$2e2bcd8739ae039 = (0, $d4FHw.default);
});
parcelRegister("bp5g1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35fb800f6bdcf84a$export$2e2bcd8739ae039);
    var $kTK0a;
    var $aIZdc;
    var $VSDnB;
    var $4zh20 = parcelRequire("4zh20");
    var $4mT2s = parcelRequire("4mT2s");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    const $35fb800f6bdcf84a$var$defaultConfig = {
        gatewayGraphqlUrl: '/gateway/api/graphql'
    };
    class $35fb800f6bdcf84a$var$ProfileCardClient {
        constructor(config, clients){
            const withDefaultConfig = {
                ...$35fb800f6bdcf84a$var$defaultConfig,
                ...config,
                gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
            };
            this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
            this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
            this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
            this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
        }
        flushCache() {
            this.userClient.flushCache();
            this.teamClient.flushCache();
            this.tcClient?.flushCache();
            this.rovoAgentClient?.flushCache();
        }
        getProfile(cloudId, userId, analytics) {
            return this.userClient.getProfile(cloudId, userId, analytics);
        }
        getTeamProfile(teamId, orgId, analytics) {
            return this.teamClient.getProfile(teamId, orgId, analytics);
        }
        getReportingLines(userId) {
            return this.tcClient?.getReportingLines(userId) || Promise.resolve({
                managers: [],
                reports: []
            });
        }
        async getTeamCentralBaseUrl(teamCentralScopes) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(this.tcClient?.options.teamCentralBaseUrl);
            if (this.tcClient === undefined) return Promise.resolve(undefined);
            const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
            if (!isGlobalExperienceWorkspace) return Promise.resolve((0, (0, parcelRequire("kTK0a")).getATLContextUrl)('team'));
            let suffix = '';
            if (teamCentralScopes !== undefined) {
                const orgId = await this.tcClient.getOrgId();
                if (orgId === null) return Promise.resolve(undefined);
                suffix += `/o/${orgId}`;
                if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
            }
            return Promise.resolve(`${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}${suffix}`);
        }
        async shouldShowGiveKudos() {
            if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
            return this.tcClient.checkWorkspaceExists();
        }
        getRovoAgentProfile(id, analytics) {
            return this.rovoAgentClient?.getProfile(id, analytics);
        }
        deleteAgent(id, analytics) {
            return this.rovoAgentClient?.deleteAgent(id, analytics);
        }
        setFavouriteAgent(id, isFavourite, analytics) {
            return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
        }
    }
    function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
        if (clients?.teamCentralClient) return clients.teamCentralClient;
        const teamCentralEnabled = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? config.teamCentralDisabled !== true : config.teamCentralUrl;
        return teamCentralEnabled ? new (0, $4mT2s.default)({
            ...config
        }) : undefined;
    }
    var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;
});
parcelRegister("4zh20", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23b1bd6752a000ab$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    const $23b1bd6752a000ab$var$createHeaders = (product, cloudId)=>{
        const config = {
            headers: {
                'X-Product': product,
                'X-Experience-Id': 'profile-card',
                'X-Cloudid': cloudId || ''
            }
        };
        return new Headers({
            ...config.headers || {}
        });
    };
    class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        makeRequest(id, cloudId) {
            const product = this.options.productIdentifier || 'rovo';
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then((response)=>response.json());
            return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then((response)=>response.json());
        }
        getProfile(id, analytics) {
            if (!id.value) return Promise.reject(new Error('Id is missing'));
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            const cache = this.getCachedProfile(id.value);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                    if (this.cache) this.setCachedProfile(id.value, data);
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        deleteAgent(agentId, analytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
                fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                    method: 'DELETE',
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers
                })).then(()=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve();
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        setFavouriteAgent(agentId, isFavourite, analytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise(async (resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
                const requestMethod = isFavourite ? 'POST' : 'DELETE';
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
                await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                    method: requestMethod,
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers
                })).then(()=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve();
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("ivXTE", function(module, exports) {
    $parcel$export(module.exports, "fireEvent", ()=>$533bc31bb6af10e0$export$43835e9acf248a15);
    $parcel$export(module.exports, "cardTriggered", ()=>$533bc31bb6af10e0$export$d50ab8a3b6975c);
    $parcel$export(module.exports, "teamRequestAnalytics", ()=>$533bc31bb6af10e0$export$c9b0e37b229a297b);
    $parcel$export(module.exports, "userRequestAnalytics", ()=>$533bc31bb6af10e0$export$12dae48763368ac9);
    $parcel$export(module.exports, "profileCardRendered", ()=>$533bc31bb6af10e0$export$41816a317479160b);
    $parcel$export(module.exports, "actionClicked", ()=>$533bc31bb6af10e0$export$fdcd134fbeb1f921);
    $parcel$export(module.exports, "reportingLinesClicked", ()=>$533bc31bb6af10e0$export$93260987012593be);
    $parcel$export(module.exports, "moreActionsClicked", ()=>$533bc31bb6af10e0$export$79befd155063a6a7);
    $parcel$export(module.exports, "teamAvatarClicked", ()=>$533bc31bb6af10e0$export$2703289b35687fde);
    $parcel$export(module.exports, "moreMembersClicked", ()=>$533bc31bb6af10e0$export$b4411a7661cf2d3f);
    $parcel$export(module.exports, "errorRetryClicked", ()=>$533bc31bb6af10e0$export$c86679da702d560e);
    $parcel$export(module.exports, "agentRequestAnalytics", ()=>$533bc31bb6af10e0$export$a9f8c9f412cf5664);
    var $6TKEY = parcelRequire("6TKEY");
    const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
    const $533bc31bb6af10e0$var$runItLater = (cb)=>{
        const requestIdleCallback = window.requestIdleCallback;
        if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
        if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
        return ()=>setTimeout(cb);
    };
    const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $533bc31bb6af10e0$var$runItLater(()=>{
            createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
        });
    };
    const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
    const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
    const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
    const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local",
                ...attributes,
                firedAt: Math.round((0, $6TKEY.getPageTime)())
            }
        });
    const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
        switch(type){
            case 'user':
                return $533bc31bb6af10e0$var$USER_SUBJECT;
            case 'team':
                return $533bc31bb6af10e0$var$TEAM_SUBJECT;
            case 'agent':
                return $533bc31bb6af10e0$var$AGENT_SUBJECT;
            default:
                return 'user';
        }
    };
    const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method)=>{
        return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
            method: method
        });
    };
    const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
    const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
    const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
    const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
    const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
    const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
    const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
    const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
    const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
    const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
});
parcelRegister("6TKEY", function(module, exports) {
    $parcel$export(module.exports, "getPageTime", ()=>$83ec369559ddc36d$export$e9faea7c41053334);
    const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
    };
    const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
    const $83ec369559ddc36d$var$initialPageTime = Date.now();
    const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
        if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
        return Date.now() - $83ec369559ddc36d$var$initialPageTime;
    };
});
parcelRegister("cZg4V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e76084040147eae1$export$2e2bcd8739ae039);
    var $iwKVT = parcelRequire("iwKVT");
    class $e76084040147eae1$export$2e2bcd8739ae039 {
        constructor(config){
            const defaults = {
                cacheSize: 10,
                cacheMaxAge: 0
            };
            this.config = {
                ...defaults,
                ...config
            };
            this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
            this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
            if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
            this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
        }
        setCachedProfile(cacheIdentifier, profile) {
            this.cache && this.cache.set(cacheIdentifier, {
                expire: Date.now() + this.config.cacheMaxAge,
                profile: profile
            });
        }
        getCachedProfile(cacheIdentifier) {
            if (!this.cache) return null;
            const cached = this.cache.get(cacheIdentifier);
            if (!cached) return null;
            if (cached.expire < Date.now()) {
                this.cache.delete(cacheIdentifier);
                return null;
            }
            this.setCachedProfile(cacheIdentifier, cached.profile);
            return cached.profile;
        }
        flushCache() {
            if (this.cache) this.cache.clear();
        }
    }
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("f3Zb8", function(module, exports) {
    $parcel$export(module.exports, "getErrorAttributes", ()=>$b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
    $parcel$export(module.exports, "handleDirectoryGraphQLErrors", ()=>$b5fa858d1f1072ea$export$7642af465ceb7f05);
    $parcel$export(module.exports, "handleAGGErrors", ()=>$b5fa858d1f1072ea$export$d9ad65d422ee3f8c);
    var $fcA5f = parcelRequire("fcA5f");
    const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
        'NotPermitted',
        'Gone',
        'IdentityUserNotFoundError'
    ];
    const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
        'IdentityUserNotFoundError',
        'TEAMS_FORBIDDEN',
        'TEAMS_TEAM_DELETED'
    ];
    const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
        'Gone'
    ];
    function $b5fa858d1f1072ea$var$isIgnoredError(error) {
        if (!error) return false;
        if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
        else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
        return false;
    }
    const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
        if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
            errorMessage: error.message,
            errorCount: error.errors.length,
            errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
            isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
            traceId: error.traceId
        };
        else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
            errorMessage: error.message,
            errorCategory: error.category,
            errorType: error.type,
            errorPath: error.path,
            errorNumber: error.errorNumber,
            isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
        };
        else if (error instanceof (0, $fcA5f.AGGErrors)) return {
            errorMessage: error.message,
            errorCount: error.errors.length,
            errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
            isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
            traceId: error.traceId
        };
        else if (error instanceof (0, $fcA5f.AGGError)) return {
            errorMessage: error.message,
            errorType: error.errorType,
            errorStatusCode: error.statusCode,
            isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
            errorCategory: error.classification
        };
        else if (error instanceof Error) {
            if (error.message.startsWith('Unable to fetch user:')) {
                if (error.hasOwnProperty('cause')) {
                    const causeError = error.cause;
                    if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
                }
                return {
                    errorMessage: error.message,
                    isSLOFailure: false
                };
            }
            return {
                errorMessage: error.message,
                isSLOFailure: true
            };
        }
        return {
            errorMessage: 'Unknown error',
            isSLOFailure: true
        };
    };
    const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
        throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
    };
    const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
        throw new (0, $fcA5f.AGGErrors)(errors, traceId);
    };
});
parcelRegister("fcA5f", function(module, exports) {
    $parcel$export(module.exports, "HttpError", ()=>$7db90b14dd6e48a6$export$65bd6083489bd8bb);
    $parcel$export(module.exports, "DirectoryGraphQLError", ()=>$7db90b14dd6e48a6$export$c1e4d0de940c06a2);
    $parcel$export(module.exports, "DirectoryGraphQLErrors", ()=>$7db90b14dd6e48a6$export$5a5fbfed34a590a1);
    $parcel$export(module.exports, "AGGError", ()=>$7db90b14dd6e48a6$export$4a696f048dcc929);
    $parcel$export(module.exports, "AGGErrors", ()=>$7db90b14dd6e48a6$export$60d8267243755b9c);
    class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
        constructor(code, reason, traceId){
            super(reason);
            this.code = code;
            this.traceId = traceId;
        }
    }
    class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
        constructor(message, category, type, extensions = {}, path = []){
            super(message);
            this.category = category;
            this.type = type;
            this.path = path.join('.');
            const { errorNumber: errorNumber, ...unknownExtension } = extensions;
            this.errorNumber = extensions.errorNumber;
            this.extensions = unknownExtension;
        }
    }
    class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
        constructor(errors, traceId){
            super('DirectoryGraphQLErrors');
            this.traceId = traceId;
            if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
            else this.errors = [];
        }
    }
    class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
        constructor(message, extensions, path = []){
            super(message);
            this.path = path?.join('.');
            const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
            this.statusCode = statusCode;
            this.errorType = errorType;
            this.classification = classification;
            this.extensions = unknownExtension;
        }
    }
    class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
        constructor(errors, traceId){
            super('AGGErrors');
            this.traceId = traceId;
            if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
            else this.errors = [];
        }
    }
});
parcelRegister("4mT2s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8d68ade6ab7f448$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cZg4V = parcelRequire("cZg4V");
    var $a6hGK = parcelRequire("a6hGK");
    var $hnIbm = parcelRequire("hnIbm");
    const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
            query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
            variables: {
                aaid: aaid
            }
        });
    let $b8d68ade6ab7f448$var$isTCReadyPromiseMap = new Map();
    const $b8d68ade6ab7f448$var$globalExperiencePromiseCache = new Map();
    const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
    class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
            this.bypassOnFailure = false;
            this.isTCReadyPromise = this.createTcReadyPromise(options);
            this.isGlobalExperienceWorkspacePromise = this.preloadIsGlobalExperienceWorkspace(options.cloudId);
            this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
        }
        createTcReadyPromise(config) {
            if (config.cloudId) {
                let promise = $b8d68ade6ab7f448$var$isTCReadyPromiseMap.get(config.cloudId);
                if (!promise) {
                    promise = this.hasTCWorkspace(config);
                    $b8d68ade6ab7f448$var$isTCReadyPromiseMap.set(config.cloudId, promise);
                }
                return promise;
            }
            return Promise.resolve(true);
        }
        getReportingLines(userId) {
            return this.isTCReadyPromise.then((workSpaceExists)=>{
                if (workSpaceExists) {
                    if (!userId) return Promise.reject(new Error('userId missing'));
                    const cache = this.getCachedProfile(userId);
                    if (cache) return Promise.resolve(cache);
                    if (this.bypassOnFailure) return Promise.resolve({});
                    return new Promise((resolve)=>{
                        this.makeRequest(userId).then((data)=>{
                            const enhancedData = {
                                managers: this.filterReportingLinesUser(data?.managers),
                                reports: this.filterReportingLinesUser(data?.reports)
                            };
                            if (this.cache) this.setCachedProfile(userId, enhancedData);
                            resolve(enhancedData);
                        }).catch((error)=>{
                            if (error?.status === 401 || error?.status === 403) this.bypassOnFailure = true;
                            resolve({});
                        });
                    });
                }
                return Promise.resolve({
                    managers: [],
                    reports: []
                });
            }, ()=>Promise.resolve({
                    managers: [],
                    reports: []
                }));
        }
        async makeRequest(userId) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) {
                if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
                const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
                const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
                return response.reportingLines;
            } else {
                if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
                const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
                const response = await (0, $hnIbm.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
                return response.reportingLines;
            }
        }
        checkWorkspaceExists() {
            return this.isTCReadyPromise.then((workSpaceExists)=>{
                if (workSpaceExists) return Promise.resolve(true);
                return Promise.resolve(false);
            }, ()=>Promise.resolve(false));
        }
        getIsGlobalExperienceWorkspace() {
            return this.isGlobalExperienceWorkspacePromise;
        }
        getOrgId() {
            return this.orgIdPromise;
        }
        preloadIsGlobalExperienceWorkspace(cloudId) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(false);
            if (cloudId === undefined) return Promise.resolve(false);
            const maybeIsGlobalExperienceWorkspaceForCloudIdPromise = $b8d68ade6ab7f448$var$globalExperiencePromiseCache.get(cloudId);
            if (maybeIsGlobalExperienceWorkspaceForCloudIdPromise !== undefined) return maybeIsGlobalExperienceWorkspaceForCloudIdPromise;
            const isGlobalExperienceWorkspaceForCloudIdPromise = this.isGlobalExperienceWorkspaceForCloudId(cloudId);
            $b8d68ade6ab7f448$var$globalExperiencePromiseCache.set(cloudId, isGlobalExperienceWorkspaceForCloudIdPromise);
            return isGlobalExperienceWorkspaceForCloudIdPromise;
        }
        hasTCWorkspace(config) {
            if (config.cloudId) {
                const maybeShardedApiPath = this.getMaybeShardedApiPath(config.cloudId);
                return fetch(`${maybeShardedApiPath}/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
                    return !res || res && res.ok;
                });
            } else return Promise.resolve(false);
        }
        async isGlobalExperienceWorkspaceForCloudId(cloudId) {
            const maybeShardedApiPath = this.getMaybeShardedApiPath(cloudId);
            try {
                const response = await fetch(`${maybeShardedApiPath}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const workspaceType = await response.text();
                    return Promise.resolve(workspaceType === 'GLOBAL_EXPERIENCE');
                }
                return Promise.resolve(false);
            } catch (err) {
                return Promise.resolve(false);
            }
        }
        preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(null);
            if (cloudId === undefined) return Promise.resolve(null);
            if (orgId !== undefined) return Promise.resolve(orgId);
            const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
            if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
            const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
            $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
            return orgIdForCloudIdPromise;
        }
        getMaybeShardedApiPath(cloudId) {
            const maybeShardedPath = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? `/townsquare/s/${cloudId}` : '/watermelon';
            return `/gateway/api${maybeShardedPath}`;
        }
        filterReportingLinesUser(users = []) {
            return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
        }
    }
    var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;
});
parcelRegister("a6hGK", function(module, exports) {
    $parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", ()=>$9b806d5a2251e5d5$export$d38a536fd806c68f);
    var $hnIbm = parcelRequire("hnIbm");
    const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
    const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
        headers.append('atl-client-name', "platform-pkg");
        headers.append('atl-client-version', "0.0.0-use.local");
        return headers;
    };
    async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
        const query = {
            query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
            variables: {
                cloudId: cloudId
            }
        };
        try {
            const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
            if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
            return tenantContexts[0].orgId;
        } catch (err) {
            return null;
        }
    }
});
parcelRegister("hnIbm", function(module, exports) {
    $parcel$export(module.exports, "directoryGraphqlQuery", ()=>$7fa677c30fceb004$export$a5b5995619d4fe36);
    $parcel$export(module.exports, "AGGQuery", ()=>$7fa677c30fceb004$export$a14afb5f82fe705);
    var $fcA5f = parcelRequire("fcA5f");
    var $f3Zb8 = parcelRequire("f3Zb8");
    const $7fa677c30fceb004$var$buildHeaders = ()=>{
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    const $7fa677c30fceb004$var$id = (headers)=>headers;
    async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
        return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
    }
    async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
        return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
    }
    async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
        const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
        const response = await fetch(new Request(serviceUrl, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify(query)
        }));
        const traceIdFromHeaders = response?.headers?.get('atl-traceid');
        if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
        const json = await response.json();
        if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
        return json.data;
    }
});
parcelRegister("fjEAi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb2f761841b49fec$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    var $5Uw6l = parcelRequire("5Uw6l");
    class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        makeRequest(teamId, _orgId) {
            if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
            return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
        }
        getProfile(teamId, orgId, analytics) {
            if (!teamId) return Promise.reject(new Error('teamId is missing'));
            const cache = this.getCachedProfile(teamId);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
                this.makeRequest(teamId, orgId).then((data)=>{
                    if (this.cache) this.setCachedProfile(teamId, data);
                    if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("5Uw6l", function(module, exports) {
    $parcel$export(module.exports, "getTeamFromAGG", ()=>$c02eddc07333bc73$export$26a8aad0c7182dd6);
    var $hnIbm = parcelRequire("hnIbm");
    const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
        const slashPos = ari.indexOf('/');
        const id = ari.slice(slashPos + 1);
        return id;
    };
    const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
        return `ari:cloud:identity::team/${teamId}`;
    };
    const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
        const { team: team } = result;
        return {
            ...team,
            id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
            members: team.members?.nodes.map(({ member: member })=>({
                    id: member.accountId,
                    fullName: member.name,
                    avatarUrl: member.picture
                }))
        };
    };
    const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
    const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
    const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
            query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
            variables: {
                teamId: $c02eddc07333bc73$export$681597d03c8a0fd2(teamId),
                siteId: siteId || 'None'
            }
        });
    const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
        headers.append('X-ExperimentalApi', 'teams-beta');
        headers.append('X-ExperimentalApi', 'team-members-beta');
        headers.append('atl-client-name', "platform-pkg");
        headers.append('atl-client-version', "0.0.0-use.local");
        return headers;
    };
    async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
        const query = $c02eddc07333bc73$export$695d743d1401e038({
            teamId: teamId,
            siteId: siteId
        });
        const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
        return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
    }
});
parcelRegister("dFLsP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eafd789fd4bdf3ff$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $2qnn4 = parcelRequire("2qnn4");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    var $hnIbm = parcelRequire("hnIbm");
    const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
        const data = {
            ...response.User
        };
        const localWeekdayIndex = new Date().getDay().toString();
        if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
        return {
            isBot: data.isBot,
            isCurrentUser: data.isCurrentUser,
            status: data.status,
            statusModifiedDate: data.statusModifiedDate || undefined,
            avatarUrl: data.avatarUrl || undefined,
            email: data.email || undefined,
            fullName: data.fullName || undefined,
            location: data.location || undefined,
            meta: data.meta || undefined,
            nickname: data.nickname || undefined,
            companyName: data.companyName || undefined,
            timestring: data.remoteTimeString || undefined,
            accountType: data.accountType || undefined
        };
    };
    const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
            query: `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`,
            variables: {
                userId: userId
            }
        });
    const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
        const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
        const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
        return user;
    };
    class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        async makeRequest(cloudId, userId) {
            const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
            const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
            const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
            const user = await userQueryPromise;
            let timestring;
            const localWeekdayIndex = new Date().getDay().toString();
            if (user.zoneinfo) {
                if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
                else timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
            }
            return {
                ...user,
                isBot: user.__typename === 'AppUser',
                isAgent: user.appType === 'agent',
                status: user.accountStatus,
                statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
                avatarUrl: user.picture,
                email: user.email,
                fullName: user.name,
                location: user.extendedProfile?.location,
                meta: user.extendedProfile?.jobTitle,
                nickname: user.nickname,
                companyName: user.extendedProfile?.organization,
                timestring: timestring
            };
        }
        getProfile(cloudId, userId, analytics) {
            if (!userId) return Promise.reject(new Error('userId missing'));
            const cacheIdentifier = `${cloudId}/${userId}`;
            const cache = this.getCachedProfile(cacheIdentifier);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
                this.makeRequest(cloudId, userId).then((data)=>{
                    if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                    if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                        duration: (0, $6TKEY.getPageTime)() - startTime
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error)
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("2qnn4", function(module, exports) {
    $parcel$export(module.exports, "localTime", ()=>$de778707e3f7ab0e$export$f0dfd716e7b023cd);
    parcelRequire("7UQ5i");
    var $9uIbX;
    const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
        if (!timezone) return null;
        try {
            return (0, (0, parcelRequire("9uIbX")).default)(new Date(), timezone, format);
        } catch (error) {
            return null;
        }
    };
});
parcelRegister("7UQ5i", function(module, exports) {
    $parcel$export(module.exports, "formatInTimeZone", ()=>(parcelRequire("9uIbX")).default);
    var $9uIbX;
});
parcelRegister("9uIbX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e9932008c468ee4$export$2e2bcd8739ae039);
    var $fwbX5;
    var $cmObS;
    var $2b4cP;
    function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("cmObS")).default)((0, (0, parcelRequire("2b4cP")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("fwbX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $b4c31d9870379ac2$var$cloneObject;
    var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
    function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
        return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
    }
    module.exports = module.exports.default;
});
parcelRegister("cpl5v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $90882d6ff669df4d$var$assign;
    function $90882d6ff669df4d$var$assign(target, dirtyObject) {
        if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
        dirtyObject = dirtyObject || {};
        for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
        return target;
    }
    module.exports = module.exports.default;
});
parcelRegister("cmObS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$900e78e49c474eed$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $920RE;
    var $2q3K8;
    var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("2q3K8")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("920RE")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("aR9Qf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7e767cfeba790ebe$var$format;
    var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));
    var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));
    var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));
    var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));
    var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));
    var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));
    var $5qguX;
    var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
    var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
    var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        if (!locale.localize) throw new RangeError('locale must contain localize property');
        if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
        var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
        if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
        var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
        var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
        var formatterOptions = {
            firstWeekContainsDate: firstWeekContainsDate,
            weekStartsOn: weekStartsOn,
            locale: locale,
            _originalDate: originalDate
        };
        var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
            var firstCharacter = substring[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
                return longFormatter(substring, locale.formatLong, formatterOptions);
            }
            return substring;
        }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
            if (substring === "''") return "'";
            var firstCharacter = substring[0];
            if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
            var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
            if (formatter) {
                if (!options.useAdditionalWeekYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedWeekYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                if (!options.useAdditionalDayOfYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedDayOfYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                return formatter(utcDate, substring, locale.localize, formatterOptions);
            }
            if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            return substring;
        }).join('');
        return result;
    }
    function $7e767cfeba790ebe$var$cleanEscapedString(input) {
        return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
    }
    module.exports = module.exports.default;
});
parcelRegister("ck8JK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8f8e2146dfa1d727$var$isValid;
    var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
        (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
        var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
        return !isNaN(date);
    }
    module.exports = module.exports.default;
});
parcelRegister("2pWQP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $1c2b912e6615b0b5$var$toDate;
    var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $1c2b912e6615b0b5$var$toDate(argument) {
        (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
        var argStr = Object.prototype.toString.call(argument);
        if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
        else {
            if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
                console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
                console.warn(new Error().stack);
            }
            return new Date(NaN);
        }
    }
    module.exports = module.exports.default;
});
parcelRegister("6eBfj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
    function $48a0f126c2293ab3$var$requiredArgs(required, args) {
        if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
    module.exports = module.exports.default;
});
parcelRegister("kvNR5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));
    var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));
    var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));
    var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));
    var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
    function $eeed6020e120f946$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $eeed6020e120f946$var$locale = {
        code: 'en-US',
        formatDistance: $eeed6020e120f946$var$_index.default,
        formatLong: $eeed6020e120f946$var$_index2.default,
        formatRelative: $eeed6020e120f946$var$_index3.default,
        localize: $eeed6020e120f946$var$_index4.default,
        match: $eeed6020e120f946$var$_index5.default,
        options: {
            weekStartsOn: 0,
            firstWeekContainsDate: 1
        }
    };
    var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
    module.exports.default = $eeed6020e120f946$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("5u9TK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
    var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
        lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds'
        },
        xSeconds: {
            one: '1 second',
            other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes'
        },
        xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes'
        },
        aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours'
        },
        xHours: {
            one: '1 hour',
            other: '{{count}} hours'
        },
        xDays: {
            one: '1 day',
            other: '{{count}} days'
        },
        aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks'
        },
        xWeeks: {
            one: '1 week',
            other: '{{count}} weeks'
        },
        aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months'
        },
        xMonths: {
            one: '1 month',
            other: '{{count}} months'
        },
        aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years'
        },
        xYears: {
            one: '1 year',
            other: '{{count}} years'
        },
        overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years'
        },
        almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years'
        }
    };
    function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
        options = options || {};
        var result;
        if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
        else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
        else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
        if (options.addSuffix) {
            if (options.comparison > 0) return 'in ' + result;
            else return result + ' ago';
        }
        return result;
    }
    module.exports = module.exports.default;
});
parcelRegister("e7AgV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
    function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a47ddb0366100c31$var$dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
    };
    var $a47ddb0366100c31$var$timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
    };
    var $a47ddb0366100c31$var$dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
    };
    var $a47ddb0366100c31$var$formatLong = {
        date: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateFormats,
            defaultWidth: 'full'
        }),
        time: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$timeFormats,
            defaultWidth: 'full'
        }),
        dateTime: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateTimeFormats,
            defaultWidth: 'full'
        })
    };
    var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
    module.exports.default = $a47ddb0366100c31$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("4raqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
    function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
        return function() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var width = options.width ? String(options.width) : args.defaultWidth;
            var format = args.formats[width] || args.formats[args.defaultWidth];
            return format;
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("8U2eY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
    var $67b54aa1e07b4b42$var$formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P'
    };
    function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
        return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
    }
    module.exports = module.exports.default;
});
parcelRegister("b9d75", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
    function $81dab50370972ecd$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $81dab50370972ecd$var$eraValues = {
        narrow: [
            'B',
            'A'
        ],
        abbreviated: [
            'BC',
            'AD'
        ],
        wide: [
            'Before Christ',
            'Anno Domini'
        ]
    };
    var $81dab50370972ecd$var$quarterValues = {
        narrow: [
            '1',
            '2',
            '3',
            '4'
        ],
        abbreviated: [
            'Q1',
            'Q2',
            'Q3',
            'Q4'
        ],
        wide: [
            '1st quarter',
            '2nd quarter',
            '3rd quarter',
            '4th quarter'
        ]
    };
    var $81dab50370972ecd$var$monthValues = {
        narrow: [
            'J',
            'F',
            'M',
            'A',
            'M',
            'J',
            'J',
            'A',
            'S',
            'O',
            'N',
            'D'
        ],
        abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    };
    var $81dab50370972ecd$var$dayValues = {
        narrow: [
            'S',
            'M',
            'T',
            'W',
            'T',
            'F',
            'S'
        ],
        short: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        abbreviated: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        wide: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ]
    };
    var $81dab50370972ecd$var$dayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        }
    };
    var $81dab50370972ecd$var$formattingDayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        }
    };
    function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;
        if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
            case 1:
                return number + 'st';
            case 2:
                return number + 'nd';
            case 3:
                return number + 'rd';
        }
        return number + 'th';
    }
    var $81dab50370972ecd$var$localize = {
        ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
        era: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$eraValues,
            defaultWidth: 'wide'
        }),
        quarter: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$quarterValues,
            defaultWidth: 'wide',
            argumentCallback: function(quarter) {
                return Number(quarter) - 1;
            }
        }),
        month: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$monthValues,
            defaultWidth: 'wide'
        }),
        day: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayValues,
            defaultWidth: 'wide'
        }),
        dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayPeriodValues,
            defaultWidth: 'wide',
            formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
            defaultFormattingWidth: 'wide'
        })
    };
    var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
    module.exports.default = $81dab50370972ecd$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("llBmH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
    function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
        return function(dirtyIndex, dirtyOptions) {
            var options = dirtyOptions || {};
            var context = options.context ? String(options.context) : 'standalone';
            var valuesArray;
            if (context === 'formatting' && args.formattingValues) {
                var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
                var width = options.width ? String(options.width) : defaultWidth;
                valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
            } else {
                var _defaultWidth = args.defaultWidth;
                var _width = options.width ? String(options.width) : args.defaultWidth;
                valuesArray = args.values[_width] || args.values[_defaultWidth];
            }
            var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
            return valuesArray[index];
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("hHwuU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));
    var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
    function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
    var $ce2fa922bf4a591b$var$matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var $ce2fa922bf4a591b$var$parseEraPatterns = {
        any: [
            /^b/i,
            /^(a|c)/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
        any: [
            /1/i,
            /2/i,
            /3/i,
            /4/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var $ce2fa922bf4a591b$var$parseMonthPatterns = {
        narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ],
        any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var $ce2fa922bf4a591b$var$parseDayPatterns = {
        narrow: [
            /^s/i,
            /^m/i,
            /^t/i,
            /^w/i,
            /^t/i,
            /^f/i,
            /^s/i
        ],
        any: [
            /^su/i,
            /^m/i,
            /^tu/i,
            /^w/i,
            /^th/i,
            /^f/i,
            /^sa/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
        any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i
        }
    };
    var $ce2fa922bf4a591b$var$match = {
        ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
            matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
            parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
            valueCallback: function(value) {
                return parseInt(value, 10);
            }
        }),
        era: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
            defaultParseWidth: 'any'
        }),
        quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
            defaultParseWidth: 'any',
            valueCallback: function(index) {
                return index + 1;
            }
        }),
        month: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
            defaultParseWidth: 'any'
        }),
        day: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
            defaultParseWidth: 'any'
        }),
        dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
            defaultMatchWidth: 'any',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
            defaultParseWidth: 'any'
        })
    };
    var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
    module.exports.default = $ce2fa922bf4a591b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("1IY7t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
    function $141888fa04c95812$var$buildMatchPatternFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var matchResult = string.match(args.matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parseResult = string.match(args.parsePattern);
            if (!parseResult) return null;
            var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("liduU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
    function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var width = options.width;
            var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
            var matchResult = string.match(matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
            var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
            var value;
            value = args.valueCallback ? args.valueCallback(key) : key;
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
        for(var key in object){
            if (object.hasOwnProperty(key) && predicate(object[key])) return key;
        }
        return undefined;
    }
    function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
        for(var key = 0; key < array.length; key++){
            if (predicate(array[key])) return key;
        }
        return undefined;
    }
    module.exports = module.exports.default;
});
parcelRegister("bQkcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;
    var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));
    var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
        (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
        var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
        return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("aSksP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
    function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
        var number = Number(dirtyNumber);
        if (isNaN(number)) return number;
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module.exports = module.exports.default;
});
parcelRegister("7f9OM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;
    var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
        (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
        var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
        var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
        return new Date(timestamp + amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("3ckvK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));
    var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));
    var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));
    var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));
    var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2542672a600cd2b8$var$dayPeriodEnum = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    };
    var $2542672a600cd2b8$var$formatters = {
        G: function(date, token, localize) {
            var era = date.getUTCFullYear() > 0 ? 1 : 0;
            switch(token){
                case 'G':
                case 'GG':
                case 'GGG':
                    return localize.era(era, {
                        width: 'abbreviated'
                    });
                case 'GGGGG':
                    return localize.era(era, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return localize.era(era, {
                        width: 'wide'
                    });
            }
        },
        y: function(date, token, localize) {
            if (token === 'yo') {
                var signedYear = date.getUTCFullYear();
                var year = signedYear > 0 ? signedYear : 1 - signedYear;
                return localize.ordinalNumber(year, {
                    unit: 'year'
                });
            }
            return $2542672a600cd2b8$var$_index.default.y(date, token);
        },
        Y: function(date, token, localize, options) {
            var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options);
            var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
            if (token === 'YY') {
                var twoDigitYear = weekYear % 100;
                return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
            }
            if (token === 'Yo') return localize.ordinalNumber(weekYear, {
                unit: 'year'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
        },
        R: function(date, token) {
            var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date);
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
        },
        u: function(date, token) {
            var year = date.getUTCFullYear();
            return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
        },
        Q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'Q':
                    return String(quarter);
                case 'QQ':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'Qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'q':
                    return String(quarter);
                case 'qq':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        M: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'M':
                case 'MM':
                    return $2542672a600cd2b8$var$_index.default.M(date, token);
                case 'Mo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'MMM':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        L: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'L':
                    return String(month + 1);
                case 'LL':
                    return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
                case 'Lo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'LLL':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        w: function(date, token, localize, options) {
            var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
            if (token === 'wo') return localize.ordinalNumber(week, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
        },
        I: function(date, token, localize) {
            var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
            if (token === 'Io') return localize.ordinalNumber(isoWeek, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
        },
        d: function(date, token, localize) {
            if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
                unit: 'date'
            });
            return $2542672a600cd2b8$var$_index.default.d(date, token);
        },
        D: function(date, token, localize) {
            var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
            if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
                unit: 'dayOfYear'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
        },
        E: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            switch(token){
                case 'E':
                case 'EE':
                case 'EEE':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        e: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'e':
                    return String(localDayOfWeek);
                case 'ee':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
                case 'eo':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'eee':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        c: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'c':
                    return String(localDayOfWeek);
                case 'cc':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
                case 'co':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'ccc':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        i: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
            switch(token){
                case 'i':
                    return String(isoDayOfWeek);
                case 'ii':
                    return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
                case 'io':
                    return localize.ordinalNumber(isoDayOfWeek, {
                        unit: 'day'
                    });
                case 'iii':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'iiiii':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'iiiiii':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'iiii':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        a: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'aaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'aaaaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        b: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
            else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
            else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'b':
                case 'bb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'bbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'bbbbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        B: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
            else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
            else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
            else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        h: function(date, token, localize) {
            if (token === 'ho') {
                var hours = date.getUTCHours() % 12;
                if (hours === 0) hours = 12;
                return localize.ordinalNumber(hours, {
                    unit: 'hour'
                });
            }
            return $2542672a600cd2b8$var$_index.default.h(date, token);
        },
        H: function(date, token, localize) {
            if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
                unit: 'hour'
            });
            return $2542672a600cd2b8$var$_index.default.H(date, token);
        },
        K: function(date, token, localize) {
            var hours = date.getUTCHours() % 12;
            if (token === 'Ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        k: function(date, token, localize) {
            var hours = date.getUTCHours();
            if (hours === 0) hours = 24;
            if (token === 'ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        m: function(date, token, localize) {
            if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: 'minute'
            });
            return $2542672a600cd2b8$var$_index.default.m(date, token);
        },
        s: function(date, token, localize) {
            if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: 'second'
            });
            return $2542672a600cd2b8$var$_index.default.s(date, token);
        },
        S: function(date, token) {
            return $2542672a600cd2b8$var$_index.default.S(date, token);
        },
        X: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'x':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'zzzz':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        t: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = Math.floor(originalDate.getTime() / 1000);
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        },
        T: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = originalDate.getTime();
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        }
    };
    function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
    }
    function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
        }
        return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
    }
    function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
        var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
        return sign + hours + delimiter + minutes;
    }
    var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
    module.exports.default = $2542672a600cd2b8$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("kFGp1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $f0c88744bd108133$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $f0c88744bd108133$var$formatters = {
        y: function(date, token) {
            var signedYear = date.getUTCFullYear();
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
        },
        M: function(date, token) {
            var month = date.getUTCMonth();
            return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
        },
        d: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
        },
        a: function(date, token) {
            var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return dayPeriodEnumValue.toUpperCase();
                case 'aaa':
                    return dayPeriodEnumValue;
                case 'aaaaa':
                    return dayPeriodEnumValue[0];
                case 'aaaa':
                default:
                    return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
            }
        },
        h: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
        },
        H: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
        },
        m: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
        },
        s: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
        },
        S: function(date, token) {
            var numberOfDigits = token.length;
            var milliseconds = date.getUTCMilliseconds();
            var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
            return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
        }
    };
    var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
    module.exports.default = $f0c88744bd108133$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("bQ2eo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
    function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    module.exports = module.exports.default;
});
parcelRegister("3xdEO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;
    var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000;
    function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
        (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
        var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6Falt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;
    var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));
    var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000;
    function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
        (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
        var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
        var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime();
        return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6nDqw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;
    var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4a53796a96b58804$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
        (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
        var weekStartsOn = 1;
        var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("hI2kM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;
    var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $ce485b424b643216$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
        (0, $ce485b424b643216$var$_index3.default)(1, arguments);
        var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);
        var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("gUvh1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;
    var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
        (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
        var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("46m4m", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;
    var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));
    var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000;
    function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
        (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
        var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
        var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime();
        return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("clhRK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;
    var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
        (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("cbqvD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;
    var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
        var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);
        var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("3ihh3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;
    var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
        var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("awKAW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'P':
                return formatLong.date({
                    width: 'short'
                });
            case 'PP':
                return formatLong.date({
                    width: 'medium'
                });
            case 'PPP':
                return formatLong.date({
                    width: 'long'
                });
            case 'PPPP':
            default:
                return formatLong.date({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'p':
                return formatLong.time({
                    width: 'short'
                });
            case 'pp':
                return formatLong.time({
                    width: 'medium'
                });
            case 'ppp':
                return formatLong.time({
                    width: 'long'
                });
            case 'pppp':
            default:
                return formatLong.time({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];
        if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
        var dateTimeFormat;
        switch(datePattern){
            case 'P':
                dateTimeFormat = formatLong.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                dateTimeFormat = formatLong.dateTime({
                    width: 'full'
                });
                break;
        }
        return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
    }
    var $7aa109506ceedd4b$var$longFormatters = {
        p: $7aa109506ceedd4b$var$timeLongFormatter,
        P: $7aa109506ceedd4b$var$dateTimeLongFormatter
    };
    var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
    module.exports.default = $7aa109506ceedd4b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("jGQTC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
    function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        utcDate.setUTCFullYear(date.getFullYear());
        return date.getTime() - utcDate.getTime();
    }
    module.exports = module.exports.default;
});
parcelRegister("5qguX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
    module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
    module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
    var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
        'D',
        'DD'
    ];
    var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
        'YY',
        'YYYY'
    ];
    function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
        return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
        return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
        if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
});
parcelRegister("920RE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6934f899b8aefb37$export$2e2bcd8739ae039);
    var $927cR = parcelRequire("927cR");
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
    var $6934f899b8aefb37$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $927cR.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $927cR.default)('long', date, options);
            }
        }
    };
    function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
    }
    var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;
});
parcelRegister("927cR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6939e400b4f30595$export$2e2bcd8739ae039);
    function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
    }
    function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("6JaJ1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e5f43d4fc19099f$export$2e2bcd8739ae039);
    var $gTcao = parcelRequire("gTcao");
    var $6Bk9v = parcelRequire("6Bk9v");
    var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
    var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
    var $4e5f43d4fc19099f$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
            return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
        }
        token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
            var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $4e5f43d4fc19099f$var$toUtcDate(date) {
        return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
        var tokens = (0, $gTcao.default)(date, timezoneString);
        var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
    function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
        if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("gTcao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4bb38695b1c145f$export$2e2bcd8739ae039);
    function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
    }
    var $c4bb38695b1c145f$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $c4bb38695b1c145f$var$dtfCache = {};
    function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
        if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $c4bb38695b1c145f$var$dtfCache[timeZone];
    }
});
parcelRegister("6Bk9v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ce5d4976aa71227$export$2e2bcd8739ae039);
    function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("2q3K8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c30e9c4205eee83$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $jxCgc = parcelRequire("jxCgc");
    var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
    var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
    var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $1c30e9c4205eee83$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $jxCgc.default)
    };
    function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
        var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $1c30e9c4205eee83$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $1c30e9c4205eee83$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
            return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
        }
        token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $1c30e9c4205eee83$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
        }
        token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
        }
        token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $1c30e9c4205eee83$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
            if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("jxCgc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e39ec715b89452b2$export$2e2bcd8739ae039);
    var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;
});
parcelRegister("2b4cP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$195fdf0d1f4870c0$export$2e2bcd8739ae039);
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $2q3K8;
    function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("2q3K8")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("9gV7o", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$f7de3dc4d7bc51ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $8S93R;
    var $5OOAU;
    var $77Oft;
    var $ivXTE = parcelRequire("ivXTE");
    var $8qsT1 = parcelRequire("8qsT1");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $aRdJp = parcelRequire("aRdJp");
    var $a3FJs = parcelRequire("a3FJs");
    var $h9eXl = parcelRequire("h9eXl");
    var $37c0Y = parcelRequire("37c0Y");
    var $dlHyi = parcelRequire("dlHyi");
    const $f7de3dc4d7bc51ad$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlockStart: 'space.400',
        paddingInline: 'space.200'
    });
    const $f7de3dc4d7bc51ad$var$avatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.300',
        left: 'space.200'
    });
    const $f7de3dc4d7bc51ad$var$cardContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        position: 'relative'
    });
    const $f7de3dc4d7bc51ad$var$AgentProfileCard = ({ agent: agent, isLoading: isLoading, isCreatedByViewingUser: isCreatedByViewingUser, cloudId: cloudId, onChatClick: onChatClick, product: product = 'rovo', hasError: hasError, errorType: errorType, onConversationStartersClick: onConversationStartersClick, resourceClient: resourceClient, addFlag: addFlag })=>{
        const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onOpenChat: onOpenChatFullScreen, onConversationStarter: onConversationStarter } = (0, $37c0Y.useAgentUrlActions)({
            cloudId: cloudId || ''
        });
        const [isStarred, setIsStarred] = (0, $5uXOq.useState)(false);
        const [starCount, setStarCount] = (0, $5uXOq.useState)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const userDefinedConversationStarters = agent?.user_defined_conversation_starters?.map((starter)=>{
            return {
                message: starter,
                type: 'user-defined'
            };
        });
        (0, $5uXOq.useEffect)(()=>{
            setIsStarred(!!agent?.favourite);
            setStarCount(agent?.favourite_count);
        }, [
            agent?.favourite,
            agent?.favourite_count
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const handleSetFavourite = (0, $5uXOq.useCallback)(async ()=>{
            if (agent?.id) try {
                await resourceClient.setFavouriteAgent(agent.id, !isStarred, fireAnalytics);
                if (isStarred) setStarCount(starCount ? starCount - 1 : 0);
                else setStarCount((starCount || 0) + 1);
                setIsStarred(!isStarred);
            } catch (error) {}
        }, [
            agent?.id,
            fireAnalytics,
            isStarred,
            resourceClient,
            starCount
        ]);
        const handleOnDelete = (0, $5uXOq.useCallback)(async ()=>{
            if (agent) try {
                await resourceClient.deleteAgent(agent.id, fireAnalytics);
                addFlag?.({
                    title: formatMessage((0, $dlHyi.messages).agentDeletedSuccessFlagTitle),
                    description: formatMessage((0, $dlHyi.messages).agentDeletedSuccessFlagDescription, {
                        agentName: agent.name
                    }),
                    type: 'success',
                    id: 'ptc-directory.agent-profile.delete-agent-success'
                });
            } catch (error) {
                addFlag?.({
                    title: formatMessage((0, $dlHyi.messages).agentDeletedErrorFlagTitle),
                    description: formatMessage((0, $dlHyi.messages).agentDeletedErrorFlagDescription),
                    type: 'error',
                    id: 'ptc-directory.agent-profile.delete-agent-error'
                });
            }
        }, [
            addFlag,
            agent,
            fireAnalytics,
            formatMessage,
            resourceClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isLoading && agent) fireAnalytics((0, $ivXTE.profileCardRendered)('agent', 'content'));
        }, [
            agent,
            fireAnalytics,
            isLoading
        ]);
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8qsT1.LoadingState), {
            profileType: "agent",
            fireAnalytics: fireAnalytics
        }));
        if (hasError || !agent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            errorType: errorType,
            fireAnalytics: fireAnalytics
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f7de3dc4d7bc51ad$var$cardContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).AgentBanner), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            height: 96,
            agentIdentityAccountId: agent.identity_account_id
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f7de3dc4d7bc51ad$var$avatarStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "xlarge",
            isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY',
            forgeAgentIconUrl: agent.icon
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            xcss: $f7de3dc4d7bc51ad$var$styles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileInfo), {
            agentName: agent.name,
            isStarred: isStarred,
            onStarToggle: handleSetFavourite,
            isHidden: agent.visibility === 'PRIVATE',
            creatorRender: agent.creatorInfo?.type && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileCreator), {
                creator: {
                    type: agent.creatorInfo?.type,
                    name: agent.creatorInfo?.name || '',
                    profileLink: agent.creatorInfo?.profileLink || ''
                },
                isLoading: false,
                onCreatorLinkClick: ()=>{}
            }),
            starCountRender: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentStarCount), {
                starCount: starCount,
                isLoading: false
            }),
            agentDescription: agent.description
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h9eXl.ConversationStarters), {
            isAgentDefault: agent.is_default,
            userDefinedConversationStarters: userDefinedConversationStarters,
            onConversationStarterClick: (conversationStarter)=>{
                onConversationStartersClick ? onConversationStartersClick(conversationStarter) : onConversationStarter({
                    agentId: agent.id,
                    prompt: conversationStarter.message
                });
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aRdJp.AgentActions), {
            agent: agent,
            isAgentCreatedByCurrentUser: isCreatedByViewingUser,
            onEditAgent: ()=>onEditAgent(agent.id),
            onCopyAgent: ()=>onCopyAgent(agent.id),
            onDuplicateAgent: ()=>onDuplicateAgent(agent.id),
            onDeleteAgent: handleOnDelete,
            onChatClick: ()=>onChatClick ? onChatClick() : onOpenChatFullScreen(agent.id)
        })));
    };
    var $f7de3dc4d7bc51ad$export$2e2bcd8739ae039 = $f7de3dc4d7bc51ad$var$AgentProfileCard;
});
parcelRegister("8S93R", function(module, exports) {
    $parcel$export(module.exports, "AgentAvatar", ()=>$5b0f0a8770070c77$export$38b71b080e1832c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $dC5iT;
    var $8CUq3;
    var $5OOAU;
    const $5b0f0a8770070c77$var$agentAvatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
    });
    const $5b0f0a8770070c77$var$innerShapeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '95%',
        width: '95%',
        clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
    });
    const $5b0f0a8770070c77$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        objectFit: 'cover',
        height: '100%',
        width: '100%'
    });
    const $5b0f0a8770070c77$var$avatarContentContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $5b0f0a8770070c77$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
        const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "aria-label": label,
            xcss: $5b0f0a8770070c77$var$agentAvatarStyles,
            style: {
                height: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                width: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                ...showBorder ? {
                    backgroundColor: '#fff'
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5b0f0a8770070c77$var$innerShapeStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5b0f0a8770070c77$var$avatarContentContainer
        }, imgUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "img",
            xcss: $5b0f0a8770070c77$var$imageStyles,
            src: imgUrl,
            alt: name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).GeneratedAvatar), {
            agentId: agentId,
            agentNamedId: agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            size: size
        }))));
    };
});
parcelRegister("5OOAU", function(module, exports) {
    $parcel$export(module.exports, "AgentBanner", ()=>$5bf0564183cfbb33$export$6efaefb8ad2fba40);
    $parcel$export(module.exports, "GeneratedAvatar", ()=>$5bf0564183cfbb33$export$96bb253b7de22616);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $dC5iT;
    var $8CUq3;
    const $5bf0564183cfbb33$var$AutoDevAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("4J75T")));
    const $5bf0564183cfbb33$var$AutoFixAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("dY96i")));
    const $5bf0564183cfbb33$var$AutoReviewAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("8S39z")));
    const $5bf0564183cfbb33$var$BacklogBuddyAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("5f7dz")));
    const $5bf0564183cfbb33$var$CommsCrafterAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("4GtXx")));
    const $5bf0564183cfbb33$var$CultureAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("ejYg5")));
    const $5bf0564183cfbb33$var$CustomerInsightAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("cVv8a")));
    const $5bf0564183cfbb33$var$DecisionDirectorAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("laQbH")));
    const $5bf0564183cfbb33$var$FeatureFlagAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("fAXjZ")));
    const $5bf0564183cfbb33$var$GenericAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("kQ0nL")));
    const $5bf0564183cfbb33$var$HireWriterAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("8upBE")));
    const $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("1DMmf")));
    const $5bf0564183cfbb33$var$MyUserManualAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("hF1ay")));
    const $5bf0564183cfbb33$var$OkrOracleAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("57MJs")));
    const $5bf0564183cfbb33$var$OpsAgentAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("l1q3R")));
    const $5bf0564183cfbb33$var$PitchPerfectorAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("15btr")));
    const $5bf0564183cfbb33$var$ProductRequirementAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("fRK36")));
    const $5bf0564183cfbb33$var$ReleaseNotesAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("kYLpd")));
    const $5bf0564183cfbb33$var$ResearchScoutAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("hvWnv")));
    const $5bf0564183cfbb33$var$SocialMediaScribeAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("eV9lH")));
    const $5bf0564183cfbb33$var$TeamConnectionAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("jux1s")));
    const $5bf0564183cfbb33$var$yellowColor = {
        primary: '#FCA700',
        secondary: '#FFC716'
    };
    const $5bf0564183cfbb33$var$purpleColor = {
        primary: '#BF63F3',
        secondary: '#D8A0F7'
    };
    const $5bf0564183cfbb33$var$greenColor = {
        primary: '#82B536',
        secondary: '#B3DF72'
    };
    const $5bf0564183cfbb33$var$blueColor = {
        primary: '#357DE8',
        secondary: '#669DF1'
    };
    const $5bf0564183cfbb33$var$colorList = [
        $5bf0564183cfbb33$var$yellowColor,
        $5bf0564183cfbb33$var$purpleColor,
        $5bf0564183cfbb33$var$greenColor,
        $5bf0564183cfbb33$var$blueColor
    ];
    const $5bf0564183cfbb33$var$avatarList = [
        $5bf0564183cfbb33$var$CustomerInsightAvatar,
        $5bf0564183cfbb33$var$BacklogBuddyAvatar,
        $5bf0564183cfbb33$var$DecisionDirectorAvatar,
        $5bf0564183cfbb33$var$CommsCrafterAvatar,
        $5bf0564183cfbb33$var$AutoDevAvatar,
        $5bf0564183cfbb33$var$OkrOracleAvatar,
        $5bf0564183cfbb33$var$CultureAvatar,
        $5bf0564183cfbb33$var$SocialMediaScribeAvatar,
        $5bf0564183cfbb33$var$TeamConnectionAvatar,
        $5bf0564183cfbb33$var$HireWriterAvatar,
        $5bf0564183cfbb33$var$OpsAgentAvatar,
        $5bf0564183cfbb33$var$ResearchScoutAvatar,
        $5bf0564183cfbb33$var$ReleaseNotesAvatar,
        $5bf0564183cfbb33$var$MyUserManualAvatar,
        $5bf0564183cfbb33$var$PitchPerfectorAvatar,
        $5bf0564183cfbb33$var$AutoDevAvatar,
        $5bf0564183cfbb33$var$AutoFixAvatar,
        $5bf0564183cfbb33$var$AutoReviewAvatar,
        $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar,
        $5bf0564183cfbb33$var$FeatureFlagAvatar,
        $5bf0564183cfbb33$var$ProductRequirementAvatar
    ];
    const $5bf0564183cfbb33$export$a834793a4d0d739e = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
    const $5bf0564183cfbb33$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        objectFit: 'cover',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar = {
        decision_director_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$DecisionDirectorAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$greenColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$greenColor.secondary
                }),
            color: $5bf0564183cfbb33$var$greenColor
        },
        user_manual_writer_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$MyUserManualAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$yellowColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$yellowColor.secondary
                }),
            color: $5bf0564183cfbb33$var$yellowColor
        },
        product_requirements_expert_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$ProductRequirementAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$yellowColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$yellowColor.secondary
                }),
            color: $5bf0564183cfbb33$var$yellowColor
        },
        issue_organizer_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$BacklogBuddyAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$greenColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$greenColor.secondary
                }),
            color: $5bf0564183cfbb33$var$greenColor
        },
        it_ops_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$OpsAgentAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$purpleColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$purpleColor.secondary
                }),
            color: $5bf0564183cfbb33$var$purpleColor
        }
    };
    const $5bf0564183cfbb33$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
        const idForAgentAvatar = agentIdentityAccountId || agentId;
        if (idForAgentAvatar) {
            const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
            const parsedId = parseInt(trimmedId, 16);
            if (isNaN(parsedId)) return 0;
            else return parsedId;
        }
        return null;
    };
    const $5bf0564183cfbb33$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
        if (typeof agentNamedId === 'string' && $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId]) {
            const ootbAvatarResult = $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId];
            return {
                render: ootbAvatarResult.getRender(size),
                color: ootbAvatarResult.color
            };
        }
        const numberId = $5bf0564183cfbb33$export$c84eb7708138dd4({
            agentIdentityAccountId: agentIdentityAccountId,
            agentId: agentId
        });
        if (numberId !== null) {
            const totalCombinations = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
            const combinationIndex = numberId % totalCombinations;
            const avatarIndex = Math.floor(combinationIndex / $5bf0564183cfbb33$var$colorList.length);
            const colorIndex = combinationIndex % $5bf0564183cfbb33$var$colorList.length;
            const Avatar = $5bf0564183cfbb33$var$avatarList[avatarIndex];
            const color = $5bf0564183cfbb33$var$colorList[colorIndex];
            return {
                render: (0, ($parcel$interopDefault($5uXOq))).createElement(Avatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: color.primary,
                    secondaryColor: color.secondary
                }),
                color: color
            };
        }
        return {
            render: (0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$GenericAvatar, {
                size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$var$blueColor.primary,
                secondaryColor: $5bf0564183cfbb33$var$blueColor.secondary
            }),
            color: $5bf0564183cfbb33$var$blueColor
        };
    };
    const $5bf0564183cfbb33$var$bannerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $5bf0564183cfbb33$var$bannerFillSpaceStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    });
    const $5bf0564183cfbb33$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
        const { color: color } = $5bf0564183cfbb33$var$getAvatarRender({
            agentNamedId: agentNamedId,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            size: 'medium'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5bf0564183cfbb33$var$bannerStyles,
                fillSpace ? $5bf0564183cfbb33$var$bannerFillSpaceStyles : undefined
            ],
            style: {
                backgroundColor: color.primary,
                height: height ? `${height}px` : undefined
            }
        });
    };
    const $5bf0564183cfbb33$export$96bb253b7de22616 = (props)=>{
        const { render: render, color: color } = $5bf0564183cfbb33$var$getAvatarRender(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5bf0564183cfbb33$var$imageStyles,
            style: {
                backgroundColor: color.primary
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, render));
    };
});
parcelRegister("4J75T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4lyg6").then(()=>parcelRequire('lOwq3'));
});
parcelRegister("dY96i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lnSiC").then(()=>parcelRequire('k9HyI'));
});
parcelRegister("8S39z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lOKtw").then(()=>parcelRequire('7r7QW'));
});
parcelRegister("5f7dz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lRNUS").then(()=>parcelRequire('27sCb'));
});
parcelRegister("4GtXx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("92TBI").then(()=>parcelRequire('k9RFh'));
});
parcelRegister("ejYg5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kX91W").then(()=>parcelRequire('dB6SD'));
});
parcelRegister("cVv8a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5L9bA").then(()=>parcelRequire('kbU5P'));
});
parcelRegister("laQbH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fJ8GX").then(()=>parcelRequire('4Ta6A'));
});
parcelRegister("fAXjZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2ZaYM").then(()=>parcelRequire('cT52Z'));
});
parcelRegister("kQ0nL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6qpze").then(()=>parcelRequire('fvSGg'));
});
parcelRegister("8upBE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2V8QL").then(()=>parcelRequire('kOgKS'));
});
parcelRegister("1DMmf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lHm9").then(()=>parcelRequire('gDfXS'));
});
parcelRegister("hF1ay", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jp977").then(()=>parcelRequire('6fzX4'));
});
parcelRegister("57MJs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hRLjL").then(()=>parcelRequire('1sn78'));
});
parcelRegister("l1q3R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6zpoJ").then(()=>parcelRequire('ljkz0'));
});
parcelRegister("15btr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cs1IH").then(()=>parcelRequire('djrSm'));
});
parcelRegister("fRK36", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5gEFD").then(()=>parcelRequire('W7C9N'));
});
parcelRegister("kYLpd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dMdTv").then(()=>parcelRequire('3pZFQ'));
});
parcelRegister("hvWnv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gLnrh").then(()=>parcelRequire('icyRb'));
});
parcelRegister("eV9lH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fj5lF").then(()=>parcelRequire('f4CgX'));
});
parcelRegister("jux1s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hZXlA").then(()=>parcelRequire('l3PeX'));
});
parcelRegister("77Oft", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCreator", ()=>$180d99d4c1dac440$export$f35b2eeaa7e3db15);
    $parcel$export(module.exports, "AgentStarCount", ()=>$180d99d4c1dac440$export$65f8fe094f79ae2);
    $parcel$export(module.exports, "AgentProfileInfo", ()=>$180d99d4c1dac440$export$e02348ba0b01a210);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1dJ6S;
    var $l8fTj;
    var $2pMF0;
    var $hqZzc;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    var $3bDjY;
    var $f18hZ;
    var $kDYSZ;
    var $cCr29;
    const $180d99d4c1dac440$var$clickableItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    });
    const $180d99d4c1dac440$var$countStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050',
        paddingInlineStart: 'space.025'
    });
    const $180d99d4c1dac440$var$nameStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    });
    const $180d99d4c1dac440$var$descriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.0',
        marginBottom: 'space.100'
    });
    const $180d99d4c1dac440$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100,
                    borderRadius: 3
                })
            });
            if (!creator) return null;
            if (creator.type === 'SYSTEM') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2pMF0")).AtlassianIcon), {
                    size: "small",
                    appearance: "brand"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, "Atlassian"))
            });
            if (creator.type === 'CUSTOMER') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, (0, parcelRequire("cCr29")).messages).agentDeactivated))
            });
            if (creator.type === 'THIRD_PARTY') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        const creatorRender = getCreatorRender();
        return creatorRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$clickableItemStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqZzc")).RovoIcon), {
            appearance: "brand",
            size: "small"
        }), creatorRender) : null;
    };
    const $180d99d4c1dac440$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ((starCount === null || starCount === undefined) && !isLoading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$countStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("l8fTj"))))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
            color: "currentColor",
            label: "",
            LEGACY_size: "small"
        }), isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            testId: "agent-profile-info-star-count-skeleton",
            isShimmering: true,
            height: 16,
            width: 75,
            borderRadius: 3
        }) : formatMessage((0, (0, parcelRequire("cCr29")).messages).starredCount, {
            count: starCount
        }));
    };
    const $180d99d4c1dac440$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100'
    });
    const $180d99d4c1dac440$var$tooltipWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginInline: 'space.100',
        position: 'relative',
        bottom: 'space.025'
    });
    const $180d99d4c1dac440$var$headingWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    const $180d99d4c1dac440$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            xcss: $180d99d4c1dac440$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $180d99d4c1dac440$var$nameStyles,
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$headingWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "span",
            size: "xlarge"
        }, agentName), isHidden && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$tooltipWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("cCr29")).messages).hiddenTooltip),
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f18hZ")).HiddenIcon), {
            label: formatMessage((0, (0, parcelRequire("cCr29")).messages).hiddenIcon)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDYSZ")).StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle
        })), creatorRender, !!agentDescription && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$descriptionStyles,
            as: "p"
        }, agentDescription), starCountRender);
    };
});
parcelRegister("l8fTj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f626abf9a5007502$var$_react = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f626abf9a5007502$var$_starUnstarred = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("1Cvrw")));
    var $f626abf9a5007502$var$_star = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $f626abf9a5007502$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f626abf9a5007502$var$StarUnstarredIcon = (props)=>$f626abf9a5007502$var$_react.default.createElement($f626abf9a5007502$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $f626abf9a5007502$var$_star.default
        }, props));
    $f626abf9a5007502$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $f626abf9a5007502$var$_default = module.exports.default = $f626abf9a5007502$var$StarUnstarredIcon;
});
parcelRegister("2pMF0", function(module, exports) {
    $parcel$export(module.exports, "AtlassianIcon", ()=>$f254a283aa81cf60$export$8a485e2e7ed91e8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $f254a283aa81cf60$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
    };
    const $f254a283aa81cf60$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor, testId: testId })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $f254a283aa81cf60$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            testId: testId
        });
    };
});
parcelRegister("1DVhQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4b6b583e25d0959$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $k5uoT;
    const $d4b6b583e25d0959$var$shimmer = (0, (0, parcelRequire("k5uoT")).skeletonShimmer)();
    const $d4b6b583e25d0959$var$shimmerKeyframes = (0, (0, parcelRequire("f8Sb3")).keyframes)($d4b6b583e25d0959$var$shimmer.keyframes);
    const $d4b6b583e25d0959$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ...$d4b6b583e25d0959$var$shimmer.css
    });
    const $d4b6b583e25d0959$var$activeShimmerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        animationName: `${$d4b6b583e25d0959$var$shimmerKeyframes}`
    });
    const $d4b6b583e25d0959$var$getKeyframes = (fromColor, toColor)=>(0, (0, parcelRequire("f8Sb3")).keyframes)({
            from: {
                backgroundColor: fromColor
            },
            to: {
                backgroundColor: toColor
            }
        });
    const $d4b6b583e25d0959$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
        const groupDataAttribute = groupName && `data-${groupName}`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $d4b6b583e25d0959$var$skeletonStyles,
                isShimmering && $d4b6b583e25d0959$var$activeShimmerStyles,
                {
                    width: width,
                    height: height,
                    borderRadius: borderRadius,
                    backgroundColor: color,
                    animationName: color && ShimmeringEndColor ? $d4b6b583e25d0959$var$getKeyframes(color, ShimmeringEndColor) : undefined
                }
            ],
            ...groupDataAttribute && {
                [groupDataAttribute]: 'true'
            }
        });
    };
    var $d4b6b583e25d0959$export$2e2bcd8739ae039 = $d4b6b583e25d0959$var$Skeleton;
});
parcelRegister("f18hZ", function(module, exports) {
    $parcel$export(module.exports, "HiddenIcon", ()=>$33a2f5af6a5e0c92$export$bce21421c351deb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $6C81H;
    const $33a2f5af6a5e0c92$export$bce21421c351deb1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6C81H"))))), props);
});
parcelRegister("6C81H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $013e232b862e20a6$var$_react = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $013e232b862e20a6$var$_UNSAFE_baseNew = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $013e232b862e20a6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $013e232b862e20a6$var$EyeOpenStrikethroughIcon = (props)=>$013e232b862e20a6$var$_react.default.createElement($013e232b862e20a6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1 1 2.919 2.919M15 15l-2.92-2.92M3.92 3.92C2.524 4.792 1.436 6.096.871 7.638a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25c1.493 0 2.898-.43 4.08-1.17M3.92 3.92l2.49 2.49m5.672 5.672L9.59 9.59m0 0a2.25 2.25 0 0 1-3.182-3.182M9.59 9.59 6.409 6.409m.005-3.495A7.7 7.7 0 0 1 8 2.75c3.255 0 6.086 2.039 7.129 4.888.085.234.085.49 0 .724a7.2 7.2 0 0 1-1.187 2.08"/>`
        }, props));
    $013e232b862e20a6$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
    var $013e232b862e20a6$var$_default = module.exports.default = $013e232b862e20a6$var$EyeOpenStrikethroughIcon;
});
parcelRegister("kDYSZ", function(module, exports) {
    $parcel$export(module.exports, "StarIconButton", ()=>$ca4e80d09e432419$export$703abb8bd2abdfa5);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $7piTm;
    var $bH1hf;
    var $5ILhZ;
    var $8CUq3;
    var $6cbg1;
    const $ca4e80d09e432419$var$pressableStarIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: 'transparent',
        padding: 'space.0',
        height: '32px',
        width: '32px'
    });
    const $ca4e80d09e432419$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca4e80d09e432419$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                $ca4e80d09e432419$var$pressableStarIconStyles,
                !visible && $ca4e80d09e432419$var$hiddenStyles
            ],
            onClick: handleToggle,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false)
        }, isStarred || isHovered ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bH1hf"))))), {
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("6cbg1")).default).removeFromFavouritesLabel),
            primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, (0, parcelRequire("6cbg1")).default).clickToFavouriteLabel),
            color: 'var(--ds-text-accent-gray)'
        }));
    };
});
parcelRegister("7piTm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));
    var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $564985c3728d4aa2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>$564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
        }, props));
    $564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;
});
parcelRegister("6cbg1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3eaaeba7b25cecb8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3eaaeba7b25cecb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeFromFavouritesLabel: {
            id: 'rovo-chat.browse-agents.remove-from-favourites-label',
            defaultMessage: 'Remove from favourites',
            description: 'Remove from favourites label'
        },
        clickToFavouriteLabel: {
            id: 'rovo-chat.browse-agents.click-to-favourite-label',
            defaultMessage: 'Not favourited, click to favourite',
            description: 'Click to favourite agent label'
        }
    });
});
parcelRegister("cCr29", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$34e6f75bfc23da7b$export$defe85febe8b728c);
    var $7VHMR;
    const $34e6f75bfc23da7b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        agentCreatedBy: {
            id: 'ai-mate.agent-profile-info.created-by',
            defaultMessage: 'Rovo Agent by {creatorNameWithLink}',
            description: 'Message to show who created this Rovo agent'
        },
        agentDeactivated: {
            id: 'ai-mate.agent-profile-info.deactivated',
            defaultMessage: '(deactivated)',
            description: 'Message to show that this agent is deactivated'
        },
        starredCount: {
            id: 'ai-mate.agent-profile-info.starred-count',
            defaultMessage: '{count} starred',
            description: 'Message to show how many times this agent has been starred by users'
        },
        hiddenIcon: {
            id: 'ai-mate.agent-profile-info.hidden-icon',
            defaultMessage: 'Hidden',
            description: 'Icon to show that this agent is hidden'
        },
        hiddenTooltip: {
            id: 'ai-mate.agent-profile-info.hidden-tooltip',
            defaultMessage: "Agent won't show in search results",
            description: 'Tooltip to explain what strikethough eye icon means'
        },
        starAgentTooltip: {
            id: 'ai-mate.agent-profile-info.star-agent-tooltip',
            defaultMessage: 'Star Agent',
            description: 'Tooltip to explain what star icon does'
        }
    });
});
parcelRegister("8qsT1", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$599d4a7a6a9f8f79$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $599d4a7a6a9f8f79$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (fireAnalytics) fireAnalytics((0, $ivXTE.profileCardRendered)(profileType, 'spinner'));
        }, [
            fireAnalytics,
            profileType
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
});
parcelRegister("jnj6z", function(module, exports) {
    $parcel$export(module.exports, "CardWrapper", ()=>$a03faa2abdc74ae6$export$6aa22a823032b784);
    $parcel$export(module.exports, "ProfileImage", ()=>$a03faa2abdc74ae6$export$a7a74ab5cffd1455);
    $parcel$export(module.exports, "ActionsFlexSpacer", ()=>$a03faa2abdc74ae6$export$d395c8d16f1e359d);
    $parcel$export(module.exports, "KudosBlobAnimation", ()=>$a03faa2abdc74ae6$export$4a8a956251d4bf6f);
    $parcel$export(module.exports, "AnimationWrapper", ()=>$a03faa2abdc74ae6$export$58517bb1b373a54c);
    $parcel$export(module.exports, "AnimatedKudosButton", ()=>$a03faa2abdc74ae6$export$6196a3f52a6944fe);
    $parcel$export(module.exports, "ActionButtonGroup", ()=>$a03faa2abdc74ae6$export$73d695ae27330056);
    $parcel$export(module.exports, "OverflowActionButtonsWrapper", ()=>$a03faa2abdc74ae6$export$ff778e5b796745a6);
    $parcel$export(module.exports, "CardContent", ()=>$a03faa2abdc74ae6$export$64ef9b8c11710c47);
    $parcel$export(module.exports, "DetailsGroup", ()=>$a03faa2abdc74ae6$export$35cf684daac137ac);
    $parcel$export(module.exports, "DisabledInfo", ()=>$a03faa2abdc74ae6$export$2062e7265a95a823);
    $parcel$export(module.exports, "FullNameLabel", ()=>$a03faa2abdc74ae6$export$1270e9c1fc39142b);
    $parcel$export(module.exports, "LozengeWrapper", ()=>$a03faa2abdc74ae6$export$75180efdd3f4d9c2);
    $parcel$export(module.exports, "CustomLozengeContainer", ()=>$a03faa2abdc74ae6$export$6ebf103500ba5a45);
    $parcel$export(module.exports, "JobTitleLabel", ()=>$a03faa2abdc74ae6$export$d6c0e5f211c8d617);
    $parcel$export(module.exports, "AppTitleLabel", ()=>$a03faa2abdc74ae6$export$4865ffa72a4d5f9);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$a03faa2abdc74ae6$export$a5e06607a5ac6158);
    $parcel$export(module.exports, "CardContainer", ()=>$a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
    $parcel$export(module.exports, "DetailsLabel", ()=>$a03faa2abdc74ae6$export$138a08882ebf7289);
    $parcel$export(module.exports, "DetailsLabelIcon", ()=>$a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
    $parcel$export(module.exports, "DetailsLabelText", ()=>$a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k5uoT;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a03faa2abdc74ae6$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
    const $a03faa2abdc74ae6$export$6aa22a823032b784 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo20"
    })("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 45, "px;");
    const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo19"
    })({
        name: "eukccz",
        styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
    });
    const $a03faa2abdc74ae6$export$d395c8d16f1e359d = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo18"
    })({
        name: "18pny36",
        styles: "flex:1 0 auto"
    });
    const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, (0, parcelRequire("f8Sb3")).keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
    const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo17"
    })("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 4 / (0, (0, parcelRequire("k5uoT")).fontSize)(), "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
    const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {
            className: "kudos-blob-animation",
            ...props
        });
    const $a03faa2abdc74ae6$export$58517bb1b373a54c = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo16"
    })("clip-path:inset(0px 0px 0px 0px round ", (0, (0, parcelRequire("k5uoT")).borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
    const $a03faa2abdc74ae6$export$6196a3f52a6944fe = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo15"
    })({
        name: "18xp5qc",
        styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
    });
    const $a03faa2abdc74ae6$export$73d695ae27330056 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo14"
    })("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
    const $a03faa2abdc74ae6$export$ff778e5b796745a6 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo13"
    })("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
    const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo12"
    })("display:flex;flex-direction:column;min-height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 17, "px;");
    const $a03faa2abdc74ae6$export$35cf684daac137ac = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo11"
    })("display:flex;flex-direction:column;margin-left:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 14.5, "px;width:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 24.5, "px;");
    const $a03faa2abdc74ae6$export$2062e7265a95a823 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo10"
    })("font-size:", (0, (0, parcelRequire("k5uoT")).fontSizeSmall)(), "px;color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
    const $a03faa2abdc74ae6$export$1270e9c1fc39142b = (0, $bWGt6.default)("h2", {
        target: "e1ebb2vo9"
    })("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $huHkE.headerTextColorInactive) : (0, $huHkE.headerTextColor), ";margin:", (props)=>$a03faa2abdc74ae6$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$a03faa2abdc74ae6$var$getFullNameMargin(props), ";}");
    const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo8"
    })({
        name: "m760b1",
        styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
    });
    const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
        target: "e1ebb2vo7"
    })({
        name: "15oqcei",
        styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
    });
    const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = (0, $bWGt6.default)("span", {
        target: "e1ebb2vo6"
    })("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
    const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = (0, $bWGt6.default)("span", {
        target: "e1ebb2vo5"
    })("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, (0, parcelRequire("k5uoT")).borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
    const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo4"
    })("align-items:center;display:flex;height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 12, "px;justify-content:center;position:relative;");
    const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo3"
    })("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, (0, parcelRequire("k5uoT")).gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`, ";overflow:hidden;");
    const $a03faa2abdc74ae6$export$138a08882ebf7289 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo2"
    })("display:flex;align-items:center;line-height:24px;font-size:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
    const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = (0, $bWGt6.default)("dt", {
        target: "e1ebb2vo1"
    })("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
    const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = (0, $bWGt6.default)("dd", {
        target: "e1ebb2vo0"
    })("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("huHkE", function(module, exports) {
    $parcel$export(module.exports, "bgColor", ()=>$61d9a2704bf54ca1$export$7dcbec377a25efc6);
    $parcel$export(module.exports, "headerBgColor", ()=>$61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
    $parcel$export(module.exports, "teamHeaderBgColor", ()=>$61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
    $parcel$export(module.exports, "headerBgColorDisabledUser", ()=>$61d9a2704bf54ca1$export$ef73fded6fab455c);
    $parcel$export(module.exports, "headerTextColor", ()=>$61d9a2704bf54ca1$export$5c2df128da90e8de);
    $parcel$export(module.exports, "headerTextColorInactive", ()=>$61d9a2704bf54ca1$export$a882617dcf7f98a6);
    $parcel$export(module.exports, "appLabelBgColor", ()=>$61d9a2704bf54ca1$export$6f79b778f6280d31);
    $parcel$export(module.exports, "appLabelTextColor", ()=>$61d9a2704bf54ca1$export$3db47a978b9599f9);
    $parcel$export(module.exports, "labelTextColor", ()=>$61d9a2704bf54ca1$export$dd73341f2a5541fa);
    $parcel$export(module.exports, "labelIconColor", ()=>$61d9a2704bf54ca1$export$5a20f73e634c37e3);
    $parcel$export(module.exports, "errorIconColor", ()=>$61d9a2704bf54ca1$export$85e73a744c5d1042);
    $parcel$export(module.exports, "errorTitleColor", ()=>$61d9a2704bf54ca1$export$be3c814f7ed506ed);
    $parcel$export(module.exports, "errorTextColor", ()=>$61d9a2704bf54ca1$export$ddf766d3bfcf965c);
    const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
    const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
    const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
    const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
    const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
});
parcelRegister("geGTf", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>(parcelRequire("gMO5Q")).ErrorBoundary);
    $parcel$export(module.exports, "ErrorIllustration", ()=>(parcelRequire("5HjZK")).ErrorIllustration);
    $parcel$export(module.exports, "ErrorMessage", ()=>(parcelRequire("cI0Td")).default);
    var $gMO5Q = parcelRequire("gMO5Q");
    var $5HjZK = parcelRequire("5HjZK");
    var $cI0Td = parcelRequire("cI0Td");
});
parcelRegister("gMO5Q", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$bd7ac2918bb58c89$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $bd7ac2918bb58c89$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            this.props.onError();
        }
        render() {
            return this.props.children;
        }
    }
    var $bd7ac2918bb58c89$export$2e2bcd8739ae039 = $bd7ac2918bb58c89$export$e926676385687eaf;
});
parcelRegister("5HjZK", function(module, exports) {
    $parcel$export(module.exports, "ErrorIllustration", ()=>$dc9c80930a9669a0$export$e0319f52fc2380b1);
    var $5uXOq = parcelRequire("5uXOq");
    const $dc9c80930a9669a0$export$e0319f52fc2380b1 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "42",
            height: "53",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "var(--ds-surface-overlay, white)",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
            fill: "url(#paint0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
            fill: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
            fill: "#C1C7D0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
            fill: "#B3BAC5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "paint0_linear",
            x1: "26.1692",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.297",
            stopColor: "#C6CBD4",
            stopOpacity: "0.8812"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.6301",
            stopColor: "#D3D7DE",
            stopOpacity: "0.748"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.9795",
            stopColor: "#E9EBEF",
            stopOpacity: "0.6082"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: "0.6"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "white"
        }))));
    };
});
parcelRegister("cI0Td", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f71e8c5b4eb5da96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $d5Zn3;
    var $coLPe = parcelRequire("coLPe");
    var $ivXTE = parcelRequire("ivXTE");
    const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
        const errorType = props.errorType || {
            reason: 'default'
        };
        const errorReason = errorType.reason;
        const { fireAnalytics: fireAnalytics, reload: reload } = props;
        const hasRetry = !!reload;
        (0, $5uXOq.useEffect)(()=>{
            fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
                hasRetry: hasRetry,
                errorType: errorReason
            }));
        }, [
            errorReason,
            fireAnalytics,
            hasRetry
        ]);
        const errorContent = ()=>{
            if (errorReason === 'NotFound') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorTitle), null, "The user is no longer available for the site");
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorTitle), null, "Oops, looks like we\u2019re having issues", (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), reload && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorText), null, "Try again and we\u2019ll give it another shot"));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorWrapper), {
            "data-testid": "profilecard-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
            label: "icon error",
            size: "xlarge"
        }), errorContent(), reload && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: reload
        }, "Try again"));
    };
    var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("coLPe", function(module, exports) {
    $parcel$export(module.exports, "ErrorWrapper", ()=>$263bdf68dbaa8e29$export$bb27b7e39840238f);
    $parcel$export(module.exports, "ErrorTitle", ()=>$263bdf68dbaa8e29$export$b065fd053267ec81);
    $parcel$export(module.exports, "ErrorText", ()=>$263bdf68dbaa8e29$export$7f714e6c560938e5);
    $parcel$export(module.exports, "TeamErrorTitle", ()=>$263bdf68dbaa8e29$export$d139ade0bdee219d);
    $parcel$export(module.exports, "TeamErrorText", ()=>$263bdf68dbaa8e29$export$90d92ccfb27352c6);
    var $k5uoT;
    var $3RZIb;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    const $263bdf68dbaa8e29$export$bb27b7e39840238f = (0, $bWGt6.default)("div", {
        target: "e1g2atxt4"
    })({
        textAlign: 'center',
        padding: "var(--ds-space-300, 24px)",
        color: (0, $huHkE.errorIconColor)
    });
    const $263bdf68dbaa8e29$export$b065fd053267ec81 = (0, $bWGt6.default)("p", {
        target: "e1g2atxt3"
    })({
        color: (0, $huHkE.errorTitleColor),
        lineHeight: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
        margin: `${"var(--ds-space-100, 8px)"} 0`
    });
    const $263bdf68dbaa8e29$export$7f714e6c560938e5 = (0, $bWGt6.default)("span", {
        target: "e1g2atxt2"
    })({
        color: (0, $huHkE.errorTextColor)
    });
    const $263bdf68dbaa8e29$export$d139ade0bdee219d = (0, $bWGt6.default)("p", {
        target: "e1g2atxt1"
    })((0, (0, parcelRequire("3RZIb")).h400));
    const $263bdf68dbaa8e29$export$90d92ccfb27352c6 = (0, $bWGt6.default)("p", {
        target: "e1g2atxt0"
    })({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        marginTop: "var(--ds-space-100, 8px)"
    });
});
parcelRegister("aRdJp", function(module, exports) {
    $parcel$export(module.exports, "AgentActions", ()=>$e34fa80969140484$export$a091e6fbe251d12f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $eCeGD;
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $h88oy;
    var $kMJs7 = parcelRequire("kMJs7");
    const $e34fa80969140484$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $e34fa80969140484$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $e34fa80969140484$var$chatPillButtonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $e34fa80969140484$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $e34fa80969140484$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $e34fa80969140484$var$actionsWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderColor: 'color.border',
        padding: 'space.200',
        marginBlockStart: 'space.200',
        color: 'color.text'
    });
    const $e34fa80969140484$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, isForgeAgent: isForgeAgent })=>{
        return isForgeAgent ? [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionCopyLink),
                onClick: onCopyAgent
            }
        ] : [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionDuplicate),
                onClick: onDuplicateAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionCopyLink),
                onClick: onCopyAgent
            }
        ];
    };
    const $e34fa80969140484$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
        return [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionEdit),
                onClick: onEditAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionDelete),
                onClick: onDeleteAgent
            }
        ];
    };
    const $e34fa80969140484$export$a091e6fbe251d12f = ({ isAgentCreatedByCurrentUser: isAgentCreatedByCurrentUser, onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, agent: agent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $5uXOq.useState)(false);
        const agentActions = $e34fa80969140484$var$buildAgentActions({
            onDuplicateAgent: onDuplicateAgent,
            onCopyAgent: onCopyAgent,
            isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY'
        });
        const agentSetting = $e34fa80969140484$var$buildAgentSettings({
            onEditAgent: onEditAgent,
            onDeleteAgent: ()=>{
                setIsDeleteModalOpen(true);
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            xcss: $e34fa80969140484$var$actionsWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            shouldFitContainer: true,
            onClick: (e)=>{
                e.stopPropagation();
                onChatClick();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $e34fa80969140484$var$chatPillButtonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatPillTextStyles
        }, formatMessage($e34fa80969140484$var$messages.actionChatToAgent)))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: "more",
                    ref: triggerRef,
                    onClick: (e)=>{
                        e.stopPropagation();
                        props.onClick?.(e);
                    }
                })),
            placement: "bottom-end"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick?.();
                }
            }, text);
        })), isAgentCreatedByCurrentUser && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            hasSeparator: true
        }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick?.();
                }
            }, text);
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kMJs7.AgentDeleteConfirmationModal), {
            isOpen: isDeleteModalOpen,
            onClose: ()=>{
                setIsDeleteModalOpen(false);
            },
            onSubmit: onDeleteAgent,
            agentId: agent.id,
            agentName: agent.name
        }));
    };
    const $e34fa80969140484$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actionChatToAgent: {
            id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
            defaultMessage: 'Chat to Agent',
            description: 'Text for the "chat to agent" action to chat to the agent'
        },
        actionDelete: {
            id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
            defaultMessage: 'Delete Agent',
            description: 'Text for the "Delete" action to delete an agent'
        },
        actionEdit: {
            id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
            defaultMessage: 'Edit Agent',
            description: 'Text for the "Edit" action to edit an agent'
        },
        actionCopyLink: {
            id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
            defaultMessage: 'Copy link',
            description: 'Text for the Copy link of an agent'
        },
        actionDuplicate: {
            id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
            defaultMessage: 'Duplicate Agent',
            description: 'Text for the Duplicate Agent action to create a duplicate'
        }
    });
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("bJeNF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));
    var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
    function $889f60aca54b55ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>$889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
            LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
        }, props));
    $889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
    var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;
});
parcelRegister("h88oy", function(module, exports) {
    $parcel$export(module.exports, "ChatPillIcon", ()=>$222c44ccbe7ec2a4$export$38f9b635c1c454e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $82RQj;
    var $jyBoJ;
    const $222c44ccbe7ec2a4$export$38f9b635c1c454e7 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("82RQj"))))), {
            ...props,
            label: "",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("jyBoJ")).default)
        });
});
parcelRegister("82RQj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5db846b1e6bcdc52$var$_react = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5db846b1e6bcdc52$var$_UNSAFE_baseNew = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5db846b1e6bcdc52$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5db846b1e6bcdc52$var$AiChatIcon = (props)=>$5db846b1e6bcdc52$var$_react.default.createElement($5db846b1e6bcdc52$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.17.1zm-3.5 2H0a.75.75 0 0 0 1.12.65zM2.63 2h10.75V.5H2.63zM14.5 3.13v8.25H16V3.13zm-1.12 9.37H4.25V14h9.13zm-9.5.1-3.5 2 .74 1.3 3.5-2zM1.5 15.25V3.13H0v12.12zm13-3.87c0 .62-.5 1.13-1.12 1.13V14A2.63 2.63 0 0 0 16 11.38zM13.38 2c.62 0 1.13.5 1.13 1.13H16A2.63 2.63 0 0 0 13.38.5zM2.63.5A2.63 2.63 0 0 0 0 3.13h1.5C1.5 2.5 2 2 2.63 2zM6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
        }, props));
    $5db846b1e6bcdc52$var$AiChatIcon.displayName = 'AiChatIcon';
    var $5db846b1e6bcdc52$var$_default = module.exports.default = $5db846b1e6bcdc52$var$AiChatIcon;
});
parcelRegister("jyBoJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2c3657b5b4eabc6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $c2c3657b5b4eabc6$var$ChatIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinejoin: "round",
            fill: "transparent"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "6",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "9",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "12",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }));
    const $c2c3657b5b4eabc6$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $c2c3657b5b4eabc6$var$ChatIconGlyph
        });
    var $c2c3657b5b4eabc6$export$2e2bcd8739ae039 = $c2c3657b5b4eabc6$var$ChatIcon;
});
parcelRegister("kMJs7", function(module, exports) {
    $parcel$export(module.exports, "AgentDeleteConfirmationModal", ()=>$9ca0177e5b141068$export$39d869cf16a68f79);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $koVbs;
    var $eCeGD;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $cgL5K;
    const $9ca0177e5b141068$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, isOpen: isOpen, onSubmit: onSubmit, agentId: agentId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleDeleteAgent = (0, $5uXOq.useCallback)(async ()=>{
            if (agentId) {
                await onSubmit();
                onClose();
            }
        }, [
            agentId,
            onClose,
            onSubmit
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage($9ca0177e5b141068$var$messages.title, {
            agentName: agentName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage($9ca0177e5b141068$var$messages.body)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage($9ca0177e5b141068$var$messages.cancelText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "danger",
            onClick: (_e, event)=>{
                handleDeleteAgent();
            }
        }, formatMessage($9ca0177e5b141068$var$messages.confirmText))))));
    };
    const $9ca0177e5b141068$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelText: {
            id: 'profilecard.agent-profile.agent-delete-confirm.cancel-text',
            defaultMessage: 'Cancel'
        },
        confirmText: {
            id: 'profilecard.agent-profile.agent-delete-confirm.confirm-text',
            defaultMessage: 'Delete'
        },
        title: {
            id: 'profilecard.agent-profile.delete-agent-confirm-title',
            defaultMessage: 'Delete "{agentName}"?',
            description: 'Title text for the delete agent confirmation modal'
        },
        body: {
            id: 'profilecard.agent-profile.delete-agent-confirm-body',
            defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
            description: 'Body text for the delete agent confirmation modal'
        },
        error: {
            id: 'profilecard.agent-profile.delete-agent-error',
            defaultMessage: 'Could not delete agent',
            description: 'Error message displayed when an agent cannot be deleted'
        },
        errorAgentNotFound: {
            id: 'profilecard.agent-profile.delete-agent-error.agent-not-found',
            defaultMessage: 'That agent could not be found.',
            description: 'Error message displayed when an agent cannot be found'
        },
        errorAgentInUse: {
            id: 'profilecard.agent-profile.delete-agent-error.agent-in-use',
            defaultMessage: 'Agent is currently in use. Try again later.',
            description: 'Error message displayed when an agent is in use'
        },
        errorIncorrectOwner: {
            id: 'profilecard.agent-profile.delete-agent-error.incorrect-owner',
            defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
            description: 'Error message displayed when the agent owner is incorrect'
        },
        agentDeletedSuccess: {
            id: 'profilecard.agent-profile.delete-agent-success',
            defaultMessage: 'Agent has been deleted!',
            description: 'Success message displayed when an agent is deleted'
        }
    });
});
parcelRegister("a3FJs", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardWrapper", ()=>$642b3278878bc39a$export$2c6604b50c274e6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $642b3278878bc39a$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '360px'
    });
    const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $642b3278878bc39a$var$styles
        }, children);
    };
});
parcelRegister("h9eXl", function(module, exports) {
    $parcel$export(module.exports, "ConversationStarters", ()=>$e92c824efb5f3806$export$ea338c37011da44c);
    var $5uXOq = parcelRequire("5uXOq");
    var $luBm6;
    var $4ns5a;
    const $e92c824efb5f3806$export$ea338c37011da44c = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
        const handleConversationStarterClick = (conversationStarter)=>{
            onConversationStarterClick(conversationStarter);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050",
            alignInline: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ns5a")).AgentConversationStarters), {
            isAgentDefault: isAgentDefault,
            onConversationStarterClick: handleConversationStarterClick,
            userDefinedConversationStarters: userDefinedConversationStarters
        }));
    };
});
parcelRegister("4ns5a", function(module, exports) {
    $parcel$export(module.exports, "getConversationStarters", ()=>$a3b222b85982a88a$export$c2d882153e0984c5);
    $parcel$export(module.exports, "AgentConversationStarters", ()=>$a3b222b85982a88a$export$171adfc74aa509c3);
    $parcel$export(module.exports, "ConversationStarters", ()=>$a3b222b85982a88a$export$ea338c37011da44c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $42CjB;
    var $lzNDe;
    var $f5TWP;
    var $1NZUH;
    var $52GXX;
    const $a3b222b85982a88a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
        const type = 'static';
        const customAgentConversationStarters = [
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion1,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion2,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion3,
                type: type
            }
        ];
        const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
        const defaultAgentConversationStarters = [
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion1,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion2,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion3,
                type: type
            }
        ];
        const getCombinedConversationStarters = ()=>{
            const shouldCombine = !isAgentDefault;
            if (shouldCombine) return [
                ...userDefinedConversationStarters,
                ...customAgentConversationStarters
            ].slice(0, 3);
            return defaultAgentConversationStarters;
        };
        return {
            userDefinedConversationStarters: userDefinedConversationStarters,
            customAgentConversationStarters: customAgentConversationStarters,
            defaultAgentConversationStarters: defaultAgentConversationStarters,
            combinedConversationStarters: getCombinedConversationStarters()
        };
    };
    const $a3b222b85982a88a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { combinedConversationStarters: combinedConversationStarters } = (0, $5uXOq.useMemo)(()=>$a3b222b85982a88a$export$c2d882153e0984c5({
                userDefinedConversationStarters: userDefinedConversationStarters,
                isAgentDefault: isAgentDefault
            }), [
            userDefinedConversationStarters,
            isAgentDefault
        ]);
        const starters = (0, $5uXOq.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                    message: starter.message,
                    type: starter.type
                } : {
                    message: formatMessage(starter.message),
                    type: starter.type
                }), [
            combinedConversationStarters,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3b222b85982a88a$export$ea338c37011da44c, {
            starters: starters,
            ...props
        });
    };
    const $a3b222b85982a88a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, starters.map((starter, index)=>{
            const isLastStarter = index === starters.length - 1;
            const chatPill = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NZUH")).ChatPill), {
                testId: "conversation-starter",
                key: starter.message,
                onClick: ()=>onConversationStarterClick(starter)
            }, starter.message);
            return isLastStarter && showReloadButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                space: "space.050",
                grow: "fill",
                alignInline: "end",
                key: starter.message
            }, chatPill, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("lzNDe"))))),
                onClick: onReloadButtonClick,
                appearance: "subtle",
                label: ""
            })) : chatPill;
        }), !!onBrowseAgentsClick && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NZUH")).BrowseAgentsPill), {
            onClick: onBrowseAgentsClick
        }));
    };
});
parcelRegister("lzNDe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fb535dae8e778b64$var$_UNSAFE_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fb535dae8e778b64$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fb535dae8e778b64$var$RetryIcon = (props)=>$fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v2.5m2.625-2.125L12.75 11l-2.625-2.625"/>`
        }, props));
    $fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
    var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;
});
parcelRegister("1NZUH", function(module, exports) {
    $parcel$export(module.exports, "ChatPill", ()=>$0fd9c621f10bd238$export$e33faa86e0996d96);
    $parcel$export(module.exports, "BrowseAgentsPill", ()=>$0fd9c621f10bd238$export$76b47032dcd9063b);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4V6HW;
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $h88oy;
    var $eCjlc;
    const $0fd9c621f10bd238$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        padding: 'space.100',
        borderRadius: 'border.radius.200',
        borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        lineHeight: '16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexShrink: 1,
        backgroundColor: 'color.background.neutral',
        ':hover': {
            backgroundColor: 'color.background.neutral.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.pressed'
        }
    });
    const $0fd9c621f10bd238$var$buttonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $0fd9c621f10bd238$var$queryTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left'
    });
    const $0fd9c621f10bd238$var$whiteSpacePreWrapStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'pre-wrap'
    });
    const $0fd9c621f10bd238$export$e33faa86e0996d96 = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$buttonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $0fd9c621f10bd238$var$queryTextStyles,
                whiteSpacePreWrap && $0fd9c621f10bd238$var$whiteSpacePreWrapStyles
            ]
        }, children))));
    const $0fd9c621f10bd238$export$76b47032dcd9063b = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$buttonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4V6HW"))))), {
            color: "currentColor",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0fd9c621f10bd238$var$queryTextStyles
        }, formatMessage((0, (0, parcelRequire("eCjlc")).default).browseAgentsPillLabel))));
    });
});
parcelRegister("4V6HW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3951b0552a35072b$var$_react = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3951b0552a35072b$var$_UNSAFE_baseNew = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3951b0552a35072b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3951b0552a35072b$var$AiAgentIcon = (props)=>$3951b0552a35072b$var$_react.default.createElement($3951b0552a35072b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m13.643 4.136-5-3a1.25 1.25 0 0 0-1.286 0l-5 3a1.25 1.25 0 0 0-.607 1.072v5.584c0 .44.23.846.607 1.072l5 3c.396.238.89.238 1.286 0l5-3a1.25 1.25 0 0 0 .607-1.072V5.208c0-.44-.23-.846-.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"/>`
        }, props));
    $3951b0552a35072b$var$AiAgentIcon.displayName = 'AiAgentIcon';
    var $3951b0552a35072b$var$_default = module.exports.default = $3951b0552a35072b$var$AiAgentIcon;
});
parcelRegister("eCjlc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34bad2d4003b85e8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34bad2d4003b85e8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        browseAgentsPillLabel: {
            id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
            defaultMessage: 'Browse Agents',
            description: 'The label displayed on the browse agents pill'
        }
    });
});
parcelRegister("52GXX", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$53d3212f8a8a35da$export$defe85febe8b728c);
    var $7VHMR;
    const $53d3212f8a8a35da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateSuggestion1: {
            id: 'ai-mate.chat-history.empty-state.suggestion1',
            defaultMessage: 'Are any of my tickets overdue?',
            description: 'The first suggestion displayed in the empty state of the chat history'
        },
        emptyStateSuggestion2: {
            id: 'ai-mate.chat-history.empty-state.suggestion2',
            defaultMessage: 'What should I work on next?',
            description: 'The second suggestion displayed in the empty state of the chat history'
        },
        emptyStateSuggestion3: {
            id: 'ai-mate.chat-history.empty-state.suggestion3',
            defaultMessage: 'Write an update about my week',
            description: 'The third suggestion displayed in the empty state of the chat history'
        },
        agentEmptyStateSuggestion1: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
            defaultMessage: 'Tell me about yourself',
            description: 'The first suggestion displayed in the empty state when an agent is selected'
        },
        agentEmptyStateSuggestion2: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
            defaultMessage: 'What can you help me with?',
            description: 'The second suggestion displayed in the empty state when an agent is selected'
        },
        agentEmptyStateSuggestion3: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
            defaultMessage: "Summarize what I'm looking at",
            description: 'The third suggestion displayed in the empty state when an agent is selected'
        }
    });
});
parcelRegister("37c0Y", function(module, exports) {
    $parcel$export(module.exports, "useAgentUrlActions", ()=>$4da156710b0b2a06$export$56665b80ee272742);
    var $5uXOq = parcelRequire("5uXOq");
    var $kTK0a;
    var $9IyQf = parcelRequire("9IyQf");
    const $4da156710b0b2a06$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    const $4da156710b0b2a06$var$ROVO_PARAM_PREFIX = 'rovoChat';
    const $4da156710b0b2a06$var$createRovoParams = (params)=>{
        const rovoParams = {};
        Object.entries(params).forEach(([key, value])=>{
            rovoParams[`${$4da156710b0b2a06$var$ROVO_PARAM_PREFIX}${$4da156710b0b2a06$export$fda91e425d265029(key)}`] = encodeURIComponent(value);
        });
        return rovoParams;
    };
    const $4da156710b0b2a06$export$56665b80ee272742 = ({ cloudId: cloudId })=>{
        const onEditAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const url = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat/agents/${agentId}/edit`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(url, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        }, [
            cloudId
        ]);
        const onCopyAgent = (agentId)=>{
            navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
        };
        const onDuplicateAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat/agents/new`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId,
                    agentId: agentId,
                    pathway: 'agents-create'
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        }, [
            cloudId
        ]);
        const onConversationStarter = ({ agentId: agentId, prompt: prompt })=>{
            const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId,
                    agentId: agentId,
                    prompt: prompt,
                    pathway: 'chat'
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        };
        const onOpenChat = (agentId)=>{
            const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId,
                    agentId: agentId
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        };
        return {
            onEditAgent: onEditAgent,
            onCopyAgent: onCopyAgent,
            onDuplicateAgent: onDuplicateAgent,
            onOpenChat: onOpenChat,
            onConversationStarter: onConversationStarter
        };
    };
});
parcelRegister("9IyQf", function(module, exports) {
    $parcel$export(module.exports, "encodeParamsToUrl", ()=>$f44b342f66021b18$export$3220405ab77f2c5d);
    const $f44b342f66021b18$export$3220405ab77f2c5d = (baseUrl, params)=>{
        const url = new URL(baseUrl);
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params))searchParams.append(key, String(value));
        url.search = searchParams.toString();
        return url.toString();
    };
});
parcelRegister("dlHyi", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b47fe3036cdacda7$export$defe85febe8b728c);
    var $7VHMR;
    const $b47fe3036cdacda7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        agentDeletedSuccessFlagTitle: {
            id: 'profilecard.agent-profile-card.delete-agent-success-flag-title',
            defaultMessage: 'Agent deleted',
            description: 'Flag message title displayed when an agent is deleted'
        },
        agentDeletedSuccessFlagDescription: {
            id: 'profilecard.agent-profile-card.delete-agent-success-flag-description',
            defaultMessage: 'You deleted {agentName}',
            description: 'Flag message description displayed when an agent is deleted'
        },
        agentDeletedErrorFlagTitle: {
            id: 'profilecard.agent-profile-card.delete-agent-error-flag-title',
            defaultMessage: 'Failed to delete Agent',
            description: 'Flag message title displayed when there is an error deleting agent'
        },
        agentDeletedErrorFlagDescription: {
            id: 'profilecard.agent-profile-card.delete-agent-error-flag-description',
            defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
            description: 'Flag message description displayed when there is an error deleting agent'
        }
    });
});
parcelRegister("6uTwi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a486335f4f64442$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cb25w;
    var $adIkV;
    var $gH4E9;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $4sfdL = parcelRequire("4sfdL");
    var $9MMkr = parcelRequire("9MMkr");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    var $6TKEY = parcelRequire("6TKEY");
    parcelRequire("geGTf");
    var $gMO5Q = parcelRequire("gMO5Q");
    var $lpWVl = parcelRequire("lpWVl");
    var $devOt = parcelRequire("devOt");
    class $6a486335f4f64442$export$f811dc569217c959 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                actions: [],
                trigger: 'hover',
                position: 'bottom-start',
                triggerLinkType: 'link'
            };
        }
        componentDidMount() {
            this._isMounted = true;
        }
        componentDidUpdate(prevProps) {
            const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
            const { visible: visible } = this.state;
            if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
                isLoading: undefined
            }, this.clientFetchProfile);
        }
        componentWillUnmount() {
            this._isMounted = false;
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
        }
        handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: false,
                data: team,
                shouldShowGiveKudos: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            });
        }
        handleClientError(err) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: true,
                error: err
            });
        }
        filterActions() {
            const actions = (0, $4sfdL.default)(this.props.actions, this.state.data);
            if (this.state.shouldShowGiveKudos) {
                const kudosAction = {
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).giveKudosButton),
                    id: 'give-kudos',
                    callback: ()=>{
                        this.openKudosDrawer();
                    },
                    link: this.kudosUrl()
                };
                return actions.concat([
                    kudosAction
                ]);
            }
            return actions;
        }
        renderPopup() {
            if (this.state.renderError) return this.props.children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gMO5Q.ErrorBoundary), {
                onError: this.onErrorBoundary
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
            }));
        }
        render() {
            if (this.props.children) return this.renderPopup();
            else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
        }
        constructor(...args){
            super(...args);
            this._isMounted = false;
            this.showTimer = 0;
            this.hideTimer = 0;
            this.openedByHover = false;
            this.openTime = 0;
            this.fireAnalytics = (payload)=>{
                if (!this._isMounted) return;
                if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
            };
            this.fireAnalyticsWithDuration = (generator)=>{
                const event = generator((0, $6TKEY.getPageTime)() - this.openTime);
                this.fireAnalytics(event);
            };
            this.hideProfilecard = (delay = 0)=>{
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
                this.hideTimer = window.setTimeout(()=>{
                    this.setState({
                        visible: false
                    });
                }, delay);
            };
            this.showProfilecard = (delay = 0)=>{
                clearTimeout(this.hideTimer);
                clearTimeout(this.showTimer);
                this.showTimer = window.setTimeout(()=>{
                    if (!this.state.visible) {
                        this.clientFetchProfile();
                        this.openTime = (0, $6TKEY.getPageTime)();
                        this.setState({
                            visible: true
                        });
                    }
                }, delay);
            };
            this.onClick = (event)=>{
                if (this.props.triggerLinkType === 'link') {
                    if ((0, $dv9z3.isBasicClick)(event)) event.preventDefault();
                }
                if (this.props.triggerLinkType === 'clickable-link') {
                    if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
                }
                if (this.props.trigger !== 'hover') {
                    this.openedByHover = false;
                    this.showProfilecard(0);
                    if (!this.state.visible) this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'click'));
                }
            };
            this.onMouseEnter = ()=>{
                if (this.props.trigger === 'click') return;
                if (!this.state.visible) {
                    this.openedByHover = true;
                    this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'hover'));
                }
                this.showProfilecard((0, $e41878b3b8cab0db$export$5b956b542f1bc1b3));
            };
            this.onMouseLeave = ()=>{
                if (this.props.trigger === 'click') return;
                if (this.openedByHover) this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
            };
            this.onClose = ()=>{
                this.hideProfilecard();
            };
            this.openKudosDrawer = ()=>{
                this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
                this.setState({
                    kudosDrawerOpen: true
                });
            };
            this.closeKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: false
                });
            };
            this.kudosUrl = ()=>{
                const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
                const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
                return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
            };
            this.stopPropagation = (event)=>{
                event.stopPropagation();
            };
            this.triggerListeners = {
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            };
            this.cardListeners = {
                onClick: this.stopPropagation,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            };
            this.state = {
                visible: false,
                isLoading: undefined,
                hasError: false,
                error: null,
                data: null,
                shouldShowGiveKudos: false,
                teamCentralBaseUrl: undefined,
                kudosDrawerOpen: false
            };
            this.clientFetchProfile = ()=>{
                const { orgId: orgId, teamId: teamId } = this.props;
                const { isLoading: isLoading } = this.state;
                if (isLoading === true) return;
                this.setState({
                    isLoading: true,
                    data: null
                }, ()=>{
                    const fireEvent = (event)=>{
                        this.fireAnalytics(event);
                    };
                    const requests = Promise.all([
                        this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                        this.props.resourceClient.shouldShowGiveKudos(),
                        this.props.resourceClient.getTeamCentralBaseUrl({
                            withOrgContext: true,
                            withSiteContext: true
                        })
                    ]);
                    requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
                });
            };
            this.onErrorBoundary = ()=>{
                this.fireAnalytics((0, $ivXTE.profileCardRendered)('team', 'errorBoundary', {
                    duration: 0
                }));
                this.setState({
                    renderError: true
                });
            };
            this.renderProfileCard = ()=>{
                const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
                const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
                const newProps = {
                    clientFetchProfile: this.clientFetchProfile,
                    actions: this.filterActions(),
                    analytics: this.fireAnalyticsWithDuration,
                    team: data || undefined,
                    generateUserLink: generateUserLink,
                    onUserClick: onUserClick,
                    viewingUserId: viewingUserId,
                    viewProfileLink: viewProfileLink,
                    viewProfileOnClick: viewProfileOnClick
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", this.cardListeners, this.state.visible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $devOt.default), {
                        analytics: this.fireAnalyticsWithDuration
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lpWVl.TeamProfileCardLazy), {
                    ...newProps,
                    isLoading: isLoading,
                    hasError: hasError,
                    errorType: error
                })));
            };
            this.renderKudosLauncher = ()=>{
                return this.state.shouldShowGiveKudos && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: null
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, (0, parcelRequire("gH4E9")).KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                }));
            };
            this.renderTrigger = (triggerProps)=>{
                const { children: children, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
                if (triggerLinkType === 'none') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderKudosLauncher(), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "data-testid": "team-profilecard-trigger-wrapper",
                    ...triggerProps,
                    ...this.triggerListeners
                }, children));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderKudosLauncher(), (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    "data-testid": "team-profilecard-trigger-wrapper",
                    style: {
                        color: 'initial',
                        textDecoration: 'none'
                    },
                    href: viewProfileLink,
                    ...triggerProps,
                    ref: triggerProps.ref,
                    ...this.triggerListeners
                }, children));
            };
        }
    }
    var $6a486335f4f64442$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($6a486335f4f64442$export$f811dc569217c959);
});
parcelRegister("adIkV", function(module, exports) {
    $parcel$export(module.exports, "GiveKudosLauncherLazy", ()=>$c3877992df568d20$export$93fe397a02fe8b76);
    var $5uXOq = parcelRequire("5uXOq");
    const $c3877992df568d20$export$93fe397a02fe8b76 = (0, $5uXOq.lazy)(()=>(parcelRequire("7TeXq")));
});
parcelRegister("7TeXq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("HRhLG")
    ]).then(()=>parcelRequire('iRLc5'));
});
parcelRegister("gH4E9", function(module, exports) {
    $parcel$export(module.exports, "KudosType", ()=>$b9e3bff5640b4187$export$4fa2020056771264);
    $parcel$export(module.exports, "FlagEventType", ()=>$b9e3bff5640b4187$export$d21f9befaa2961a);
    $parcel$export(module.exports, "isFlagEventTypeValue", ()=>$b9e3bff5640b4187$export$7a1fc1a1b0477464);
    var $b9e3bff5640b4187$export$4fa2020056771264;
    (function(KudosType) {
        KudosType["INDIVIDUAL"] = "individual";
        KudosType["TEAM"] = "team";
    })($b9e3bff5640b4187$export$4fa2020056771264 || ($b9e3bff5640b4187$export$4fa2020056771264 = {}));
    var $b9e3bff5640b4187$export$d21f9befaa2961a;
    (function(FlagEventType) {
        FlagEventType["KUDOS_CREATED"] = "kudos-created";
        FlagEventType["KUDOS_FAILED"] = "kudos-failed";
        FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
        FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
        FlagEventType["DIRTY"] = "dirty";
        FlagEventType["CLOSE"] = "close";
    })($b9e3bff5640b4187$export$d21f9befaa2961a || ($b9e3bff5640b4187$export$d21f9befaa2961a = {}));
    const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
        return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
    };
});
parcelRegister("4sfdL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1251cd76451c32$export$2e2bcd8739ae039);
    const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
        return actions.filter((action)=>{
            if (!action.shouldRender) return true;
            else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
            return action.shouldRender(data);
        });
    };
    var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;
});
parcelRegister("9MMkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b852a44de86ce4d8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b852a44de86ce4d8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inactiveAccountMsg: {
            id: 'pt.profile-card.inactive.account',
            defaultMessage: 'Account deactivated',
            description: 'A text in a grey lozenge shows that this user is inactive'
        },
        generalDescMsgForDisabledUser: {
            id: 'pt.profile-card.general.msg.disabled.user',
            defaultMessage: 'You can no longer collaborate with this person.',
            description: 'A first sentence of a long text explains this user is inactive/closed'
        },
        inactiveAccountDescMsgNoDate: {
            id: 'pt.profile-card.inactive.account.no.date',
            defaultMessage: 'Their account has been deactivated.',
            description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateThisWeek: {
            id: 'pt.profile-card.inactive.account.has.date.this.week',
            defaultMessage: 'Their account was deactivated this week.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateThisMonth: {
            id: 'pt.profile-card.inactive.account.has.date.this.month',
            defaultMessage: 'Their account was deactivated this month.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateLastMonth: {
            id: 'pt.profile-card.inactive.account.has.date.last.month',
            defaultMessage: 'Their account was deactivated last month.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateAFewMonths: {
            id: 'pt.profile-card.inactive.account.has.date.a.few.months',
            defaultMessage: 'Their account has been deactivated for a few months.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateSeveralMonths: {
            id: 'pt.profile-card.inactive.account.has.date.several.months',
            defaultMessage: 'Their account has been deactivated for several months.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateMoreThanAYear: {
            id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
            defaultMessage: 'Their account has been deactivated for more than a year.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        closedAccountMsg: {
            id: 'pt.profile-card.closed.account',
            defaultMessage: 'Account deleted',
            description: 'A text in a grey lozenge shows that this user is closed/deleted'
        },
        closedAccountDescMsgNoDate: {
            id: 'pt.profile-card.closed.account.no.date',
            defaultMessage: 'Their account has been deleted.',
            description: 'A long text explains this user is closed when we do not know the date of starting to close'
        },
        closedAccountDescMsgHasDateThisWeek: {
            id: 'pt.profile-card.closed.account.has.date.this.week',
            defaultMessage: 'Their account was deleted this week.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateThisMonth: {
            id: 'pt.profile-card.closed.account.has.date.this.month',
            defaultMessage: 'Their account was deleted this month.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateLastMonth: {
            id: 'pt.profile-card.closed.account.has.date.last.month',
            defaultMessage: 'Their account was deleted last month.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateAFewMonths: {
            id: 'pt.profile-card.closed.account.has.date.a.few.months',
            defaultMessage: 'Their account has been deleted for a few months.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateSeveralMonths: {
            id: 'pt.profile-card.closed.account.has.date.several.months',
            defaultMessage: 'Their account has been deleted for several months.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateMoreThanAYear: {
            id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
            defaultMessage: 'Their account has been deleted for more than a year.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        disabledAccountDefaultName: {
            id: 'pt.profile-card.disabled.account.default.name',
            defaultMessage: 'Former user',
            description: 'A default name when we cannot get name of an inactive or closed user'
        },
        teamViewProfile: {
            id: 'pt.team-profile-card.team.action.view-profile',
            defaultMessage: 'View profile',
            description: "Button that takes you to view this team\u2019s profile"
        },
        memberCount: {
            id: 'pt.team-profile-card.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team'
        },
        memberCountIncludingYou: {
            id: 'pt.team-profile-card.team.member.count-including-you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team and highlight that the user is a member'
        },
        membersMoreThan50: {
            id: 'pt.team-profile-card.team.member.many',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the team has more than 50 members'
        },
        membersMoreThan50IncludingYou: {
            id: 'pt.team-profile-card.team.member.many-including-you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
        },
        teamErrorTitle: {
            id: 'pt.team-profile-card.error.title',
            defaultMessage: "We\u2019re having trouble retrieving this teams information",
            description: 'Title for an error view explaining that data for this team cannot be accessed'
        },
        teamErrorText: {
            id: 'pt.team-profile-card.error.suggestion',
            defaultMessage: 'Wait a few moments, then try again.',
            description: 'Second line suggesting how to fix the issue'
        },
        teamErrorButton: {
            id: 'pt.team-profile-card.error.refresh-button',
            defaultMessage: 'Try again',
            description: 'Text on a button that will try to get the data again when clicked'
        },
        teamForbiddenErrorStateTitle: {
            id: 'pt.team-profile-card.forbidden-error-state.title',
            defaultMessage: "We can\u2019t show you this team",
            description: 'Title for the error state that is displayed when a user lacks access to the team'
        },
        teamForbiddenErrorStateDescription: {
            id: 'pt.team-profile-card.forbidden-error-state.description',
            defaultMessage: "You don\u2019t have access to view this team.",
            description: 'Description for the error state that is displayed when a user lacks access to the team'
        },
        managerSectionHeading: {
            id: 'pt.team-profile-card.manager.heading',
            defaultMessage: 'Manager',
            description: "Title for a section on the profile card that show the user's direct manager"
        },
        directReportsSectionHeading: {
            id: 'pt.team-profile-card.directReports.heading',
            defaultMessage: 'Direct reports',
            description: "Title for a section on the profile card that show the user's direct reports"
        },
        giveKudosButton: {
            id: 'pt.profile-card.give-kudos',
            defaultMessage: 'Give kudos',
            description: 'Title for the button on the profile card for a user to give a kudos'
        },
        profileCardMoreIconLabel: {
            id: 'pt.profile-card.more-icon-label',
            defaultMessage: 'More',
            description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
        }
    });
    var $b852a44de86ce4d8$export$2e2bcd8739ae039 = $b852a44de86ce4d8$var$messages;
});
parcelRegister("dv9z3", function(module, exports) {
    $parcel$export(module.exports, "isBasicClick", ()=>$29a366424d2cda97$export$eddcd8a5b7e09991);
    const $29a366424d2cda97$export$eddcd8a5b7e09991 = (event)=>{
        return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    };
});
const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;
parcelRegister("lpWVl", function(module, exports) {
    $parcel$export(module.exports, "TeamProfileCardLazy", ()=>$9bee5bfea0ce3d14$export$82a49d896f41ca78);
    var $5uXOq = parcelRequire("5uXOq");
    const $9bee5bfea0ce3d14$export$82a49d896f41ca78 = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("AF8aN"))));
});
parcelRegister("AF8aN", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$3bb916baa86f0602$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jnhNB;
    var $2rqOp;
    var $fVnbM;
    var $jhVLw;
    var $bJeNF;
    var $3Z96c;
    var $eZUJu;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $3bDjY;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $coLPe = parcelRequire("coLPe");
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    parcelRequire("geGTf");
    var $5HjZK = parcelRequire("5HjZK");
    var $drhKV = parcelRequire("drhKV");
    var $devOt = parcelRequire("devOt");
    const $3bb916baa86f0602$var$LARGE_MEMBER_COUNT = 50;
    const $3bb916baa86f0602$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
    function $3bb916baa86f0602$var$onMemberClick(callback, userId, analytics, index, hasHref) {
        return (event)=>{
            analytics((duration)=>(0, $ivXTE.teamAvatarClicked)({
                    duration: duration,
                    hasHref: hasHref,
                    hasOnClick: !!callback,
                    index: index
                }));
            if (callback) callback(userId, event);
        };
    }
    const $3bb916baa86f0602$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou })=>{
        const count = members ? members.length : 0;
        const message = includingYou ? count >= $3bb916baa86f0602$var$LARGE_MEMBER_COUNT ? (0, $9MMkr.default).membersMoreThan50IncludingYou : (0, $9MMkr.default).memberCountIncludingYou : count >= $3bb916baa86f0602$var$LARGE_MEMBER_COUNT ? (0, $9MMkr.default).membersMoreThan50 : (0, $9MMkr.default).memberCount;
        const isMoreMembersOpen = (0, $5uXOq.useRef)(false);
        const onMoreClick = (0, $5uXOq.useCallback)(()=>{
            const { current: isOpen } = isMoreMembersOpen;
            if (!isOpen) analytics((duration)=>(0, $ivXTE.moreMembersClicked)({
                    duration: duration,
                    memberCount: count
                }));
            isMoreMembersOpen.current = !isOpen;
        }, [
            analytics,
            count
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.MemberCount), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...message,
            values: {
                count: count
            }
        })), members && members.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.AvatarSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: members.map((member, index)=>{
                const href = generateUserLink?.(member.id);
                const onClick = $3bb916baa86f0602$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                return {
                    key: member.id,
                    name: member.fullName,
                    src: member.avatarUrl,
                    href: href,
                    onClick: onClick
                };
            }),
            maxCount: 9,
            showMoreButtonProps: {
                onClick: onMoreClick
            },
            testId: "profilecard-avatar-group"
        })));
    };
    function $3bb916baa86f0602$var$onActionClick(action, analytics, index) {
        return (event, ...args)=>{
            analytics((duration)=>(0, $ivXTE.actionClicked)('team', {
                    duration: duration,
                    hasHref: !!action.link,
                    hasOnClick: !!action.callback,
                    index: index,
                    actionId: action.id || ''
                }));
            if (action.callback && (0, $dv9z3.isBasicClick)(event)) {
                event.preventDefault();
                action.callback(event, ...args);
            }
        };
    }
    const $3bb916baa86f0602$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
        const isGiveKudosActionButton = action.id === $3bb916baa86f0602$var$GIVE_KUDOS_ACTION_ID;
        const actionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            key: action.id || index,
            onClick: $3bb916baa86f0602$var$onActionClick(action, analytics, index),
            href: action.link,
            shouldFitContainer: true
        }, action.label, isGiveKudosActionButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.KudosBlobAnimation), null))));
        if (isGiveKudosActionButton) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimatedKudosButton), null, actionButton);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.WrappedButton), null, actionButton);
    };
    const $3bb916baa86f0602$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
        const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
        const count = actions.length;
        const onMoreClick = (0, $5uXOq.useCallback)((shouldBeOpen)=>{
            if (shouldBeOpen) analytics((duration)=>(0, $ivXTE.moreActionsClicked)('team', {
                    duration: duration,
                    numActions: count + 2
                }));
            setOpen(shouldBeOpen);
        }, [
            analytics,
            count
        ]);
        if (!count) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.MoreButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setOpen(false),
            placement: "bottom-start",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, actions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                        onClick: $3bb916baa86f0602$var$onActionClick(action, analytics, index + 2),
                        key: action.id || index,
                        href: action.link
                    }, action.label))),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    testId: "more-actions-button",
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>onMoreClick(!isOpen),
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        spacing: "spacious",
                        label: "actions",
                        color: "currentColor"
                    })
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
        }));
    };
    const $3bb916baa86f0602$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
        if (!actions) return null;
        const extraActions = actions.slice(2);
        const initialActions = actions.slice(0, 2);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.ActionButtons), null, initialActions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ActionButton, {
                action: action,
                analytics: analytics,
                index: index,
                key: index
            })), extraActions && (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ExtraActions, {
            actions: extraActions,
            analytics: analytics
        }));
    };
    const $3bb916baa86f0602$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick })=>{
        const allActions = [
            {
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamViewProfile),
                link: viewProfileLink,
                callback: viewProfileOnClick,
                id: 'view-profile'
            },
            ...actions || []
        ];
        const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'content', {
                    duration: duration,
                    numActions: allActions.length,
                    memberCount: team.members?.length,
                    includingYou: includingYou,
                    descriptionLength: team.description.length,
                    titleLength: team.displayName.length
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
            "data-testid": "team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardHeader), {
            image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: team.displayName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.TeamName), null, team.displayName)), (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$TeamMembers, {
            analytics: analytics,
            members: team.members,
            generateUserLink: generateUserLink,
            includingYou: includingYou,
            onUserClick: onUserClick
        }), team.description.trim() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.DescriptionWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.Description), null, team.description)), (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ButtonSection, {
            actions: allActions,
            analytics: analytics
        })));
    };
    const $3bb916baa86f0602$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
        const hasRetry = !!clientFetchProfile;
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'error', {
                    duration: duration,
                    hasRetry: hasRetry
                }));
        }, [
            analytics,
            hasRetry
        ]);
        const retry = (0, $5uXOq.useCallback)(()=>{
            analytics((duration)=>(0, $ivXTE.errorRetryClicked)({
                    duration: duration
                }));
            if (clientFetchProfile) clientFetchProfile();
        }, [
            analytics,
            clientFetchProfile
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorWrapper), {
            "data-testid": "team-profilecard-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5HjZK.ErrorIllustration), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.TeamErrorTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.TeamErrorText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorText)), clientFetchProfile && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.ActionButtons), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.WrappedButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            testId: "client-fetch-profile-button",
            shouldFitContainer: true,
            onClick: retry,
            isLoading: isLoading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorButton)))));
    };
    const $3bb916baa86f0602$var$TeamProfileCard = (props)=>{
        const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
        if (hasError) {
            if (errorType?.reason === 'TEAMS_FORBIDDEN') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $drhKV.default), {
                analytics: analytics
            });
            else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
                "data-testid": "team-profilecard"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ErrorMessage, {
                analytics: analytics,
                clientFetchProfile: clientFetchProfile,
                isLoading: isLoading
            }));
        }
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $devOt.default), {
            analytics: analytics
        });
        if (team) return (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$TeamProfilecardContent, {
            ...props,
            team: team
        });
        return null;
    };
    var $3bb916baa86f0602$export$2e2bcd8739ae039 = $3bb916baa86f0602$var$TeamProfileCard;
});
parcelRegister("iE5Av", function(module, exports) {
    $parcel$export(module.exports, "CardWrapper", ()=>$cfab992fac525e86$export$6aa22a823032b784);
    $parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", ()=>$cfab992fac525e86$export$66ecf3d3b7b1c016);
    $parcel$export(module.exports, "CardHeader", ()=>$cfab992fac525e86$export$5665775b26e26c5d);
    $parcel$export(module.exports, "CardContent", ()=>$cfab992fac525e86$export$64ef9b8c11710c47);
    $parcel$export(module.exports, "TeamName", ()=>$cfab992fac525e86$export$8fe6f0aed18a58c7);
    $parcel$export(module.exports, "MemberCount", ()=>$cfab992fac525e86$export$1cbd03a20253b620);
    $parcel$export(module.exports, "AvatarSection", ()=>$cfab992fac525e86$export$82a6f3ee677bdbfe);
    $parcel$export(module.exports, "DescriptionWrapper", ()=>$cfab992fac525e86$export$2bf1f2b0d31b60fc);
    $parcel$export(module.exports, "Description", ()=>$cfab992fac525e86$export$393edc798c47379d);
    $parcel$export(module.exports, "ActionButtons", ()=>$cfab992fac525e86$export$88c65d2d98aab183);
    $parcel$export(module.exports, "WrappedButton", ()=>$cfab992fac525e86$export$44e087c32db6077d);
    $parcel$export(module.exports, "MoreButton", ()=>$cfab992fac525e86$export$7f94856880993f27);
    $parcel$export(module.exports, "LoadingWrapper", ()=>$cfab992fac525e86$export$43a792a870d28db2);
    $parcel$export(module.exports, "AccessLockSVGWrapper", ()=>$cfab992fac525e86$export$71bcd744fda975e5);
    var $k5uoT;
    var $3RZIb;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $cfab992fac525e86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $cfab992fac525e86$export$a443be8291b92497 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f414"
    })({
        name: "ck88l6",
        styles: "display:inherit"
    });
    const $cfab992fac525e86$export$6aa22a823032b784 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f413"
    })({
        backgroundColor: (0, $huHkE.bgColor),
        borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`,
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 40}px`,
        position: 'relative',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
    });
    const $cfab992fac525e86$export$66ecf3d3b7b1c016 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f412"
    })({
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 40}px`,
        position: 'relative'
    });
    const $cfab992fac525e86$export$5665775b26e26c5d = (0, $bWGt6.default)("div", {
        target: "e1kkd6f411"
    })("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $huHkE.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 16, "px;");
    const $cfab992fac525e86$export$64ef9b8c11710c47 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f410"
    })({
        display: 'flex',
        flexDirection: 'column',
        padding: "var(--ds-space-300, 24px)",
        minHeight: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 13}px`
    });
    const $cfab992fac525e86$export$8fe6f0aed18a58c7 = (0, $bWGt6.default)("h6", {
        target: "e1kkd6f49"
    })((0, (0, parcelRequire("3RZIb")).h600), "text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
    const $cfab992fac525e86$export$1cbd03a20253b620 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f48"
    })({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        marginTop: "var(--ds-space-050, 4px)"
    });
    const $cfab992fac525e86$export$82a6f3ee677bdbfe = (0, $bWGt6.default)("div", {
        target: "e1kkd6f47"
    })({
        name: "li9rw7",
        styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
    });
    const $cfab992fac525e86$export$2bf1f2b0d31b60fc = (0, $bWGt6.default)("div", {
        target: "e1kkd6f46"
    })({
        name: "vi4bqq",
        styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
    });
    const $cfab992fac525e86$export$393edc798c47379d = (0, $bWGt6.default)("span", {
        target: "e1kkd6f45"
    })({
        name: "yog5y2",
        styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
    });
    const $cfab992fac525e86$export$88c65d2d98aab183 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f44"
    })({
        width: 'calc(100% + 8px)',
        display: 'flex',
        justifyContent: 'space-between',
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
        backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
    });
    const $cfab992fac525e86$export$44e087c32db6077d = (0, $bWGt6.default)("div", {
        target: "e1kkd6f43"
    })({
        name: "1svotkm",
        styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
    });
    const $cfab992fac525e86$export$7f94856880993f27 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f42"
    })({
        name: "9kivhj",
        styles: "margin-left:var(--ds-space-100, 8px)"
    });
    const $cfab992fac525e86$export$43a792a870d28db2 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f41"
    })({
        name: "o13o72",
        styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
    });
    const $cfab992fac525e86$export$71bcd744fda975e5 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f40"
    })({
        name: "ifz8jz",
        styles: "margin-bottom:var(--ds-space-300, 24px)"
    });
});
parcelRegister("drhKV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3602a6790b0d2a05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $hTEpF;
    var $9MMkr = parcelRequire("9MMkr");
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $fMbSw = parcelRequire("fMbSw");
    var $3602a6790b0d2a05$export$2e2bcd8739ae039 = (props)=>{
        const { analytics: analytics } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'error', {
                    duration: duration
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.TeamForbiddenErrorStateWrapper), {
            "data-testid": "team-profilecard-forbidden-error-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: intl.formatMessage((0, $9MMkr.default).teamForbiddenErrorStateTitle),
            description: intl.formatMessage((0, $9MMkr.default).teamForbiddenErrorStateDescription),
            renderImage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.AccessLockSVGWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fMbSw.default), null))
        }));
    };
});
parcelRegister("fMbSw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3cdb196cf5a3a60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $f3cdb196cf5a3a60$var$AccessLockSVG = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "191",
            height: "222",
            viewBox: "0 0 191 222",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0.400391H190.2V221.9H0V0.400391Z",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
            fill: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
            fill: "#FFAB00"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            style: {
                mixBlendMode: 'multiply'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
            fill: "#FFE380"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
            fill: "#FFAB00"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
            fill: "#253858"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
            fill: "#2684FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
            fill: "#2684FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
            fill: "#FFFAE5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0.400391H190.2V221.9H0V0.400391Z",
            fill: "white"
        }))));
    };
    var $f3cdb196cf5a3a60$export$2e2bcd8739ae039 = $f3cdb196cf5a3a60$var$AccessLockSVG;
});
parcelRegister("devOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d55bb5393d16af5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $7d55bb5393d16af5$export$2e2bcd8739ae039 = (props)=>{
        const { analytics: analytics } = props;
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'spinner', {
                    duration: duration
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
            "data-testid": "team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardHeader), {
            isLoading: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.LoadingWrapper), {
            "data-testid": "team-profilecard-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null))));
    };
});
parcelRegister("lrMir", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "ProfilecardInternal", ()=>$4585e7f6ae851e43$export$64e0275ede8ab792);
    $parcel$export(module.exports, "default", ()=>$4585e7f6ae851e43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cb25w;
    var $ujWmd;
    var $fVnbM;
    var $jhVLw;
    var $eZJjh;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    var $6TKEY = parcelRequire("6TKEY");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $jHIf5 = parcelRequire("jHIf5");
    var $cfBc7 = parcelRequire("cfBc7");
    const $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
    const $4585e7f6ae851e43$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
        const kudosUrl = (0, $5uXOq.useMemo)(()=>{
            const recipientId = userId ? `&recipientId=${userId}` : '';
            const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
            return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
        }, [
            cloudId,
            teamCentralBaseUrl,
            userId
        ]);
        const kudosButtonCallback = (0, $5uXOq.useCallback)(()=>{
            if (openKudosDrawer) openKudosDrawer();
            else window.open(kudosUrl);
        }, [
            kudosUrl,
            openKudosDrawer
        ]);
        const kudosAction = (0, $5uXOq.useMemo)(()=>{
            return {
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).giveKudosButton),
                id: $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID,
                callback: kudosButtonCallback,
                link: kudosUrl
            };
        }, [
            kudosButtonCallback,
            kudosUrl
        ]);
        return {
            kudosAction: kudosAction,
            kudosButtonCallback: kudosButtonCallback,
            kudosUrl: kudosUrl
        };
    };
    const $4585e7f6ae851e43$var$Wrapper = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
            "data-testid": "profilecard",
            role: "dialog",
            "aria-labelledby": "profilecard-name-label"
        }, props.children);
    const $4585e7f6ae851e43$export$64e0275ede8ab792 = (props)=>{
        const [openTime] = (0, $5uXOq.useState)((0, $6TKEY.getPageTime)());
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const fireAnalyticsWithDuration = (0, $5uXOq.useCallback)((generator)=>{
            const elapsed = (0, $6TKEY.getPageTime)() - openTime;
            const event = generator(elapsed);
            fireAnalytics(event);
        }, [
            fireAnalytics,
            openTime
        ]);
        const { kudosAction: kudosAction } = $4585e7f6ae851e43$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
        const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
        const realActions = (0, $5uXOq.useMemo)(()=>{
            if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
            return actions.concat([
                kudosAction
            ]);
        }, [
            actions,
            isCurrentUser,
            isKudosEnabled,
            kudosAction,
            status
        ]);
        const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
        const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
        (0, $5uXOq.useEffect)(()=>{
            if (canRender) fireAnalyticsWithDuration((duration)=>(0, $ivXTE.profileCardRendered)('user', 'content', {
                    duration: duration,
                    numActions: realActions.length
                }));
        }, [
            canRender,
            fireAnalyticsWithDuration,
            realActions
        ]);
        if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            reload: props.clientFetchProfile,
            errorType: props.errorType || null,
            fireAnalytics: fireAnalytics
        }));
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$LoadingView, {
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        }));
        if (!canRender) return null;
        const isDisabledUser = status === 'inactive' || status === 'closed';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardContainer), {
            isDisabledUser: isDisabledUser,
            withoutElevation: props.withoutElevation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ProfileImage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xlarge",
            src: status !== 'closed' ? props.avatarUrl : undefined,
            borderColor: `var(--ds-shadow-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cfBc7.ProfileCardDetails), {
            ...props,
            status: status,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        }), realActions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ActionsFlexSpacer), null), (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Actions, {
            actions: realActions,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration,
            isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
        })))));
    };
    const $4585e7f6ae851e43$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
        const onActionClick = (0, $5uXOq.useCallback)((action, args, event, index)=>{
            fireAnalyticsWithDuration((duration)=>(0, $ivXTE.actionClicked)('user', {
                    duration: duration,
                    hasHref: !!action.link,
                    hasOnClick: !!action.callback,
                    index: index,
                    actionId: action.id || 'no-id-specified'
                }));
            if (action.callback && (0, $dv9z3.isBasicClick)(event)) {
                event.preventDefault();
                action.callback(event, ...args);
            }
        }, [
            fireAnalyticsWithDuration
        ]);
        if (!actions || actions.length === 0) return null;
        const regularActions = actions.slice(0, (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD));
        const overflowActions = actions.length > (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $jHIf5.ACTION_OVERFLOW_THRESHOLD)) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ActionButtonGroup), {
            "data-testid": "profilecard-actions"
        }, regularActions.map((action, index)=>{
            const isKudos = action.id === $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID;
            const button = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
                isInset: true,
                key: `profile-card-action-focus-ring_${action.id || index}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "default",
                key: action.id || index,
                onClick: (event, ...args)=>onActionClick(action, args, event, index),
                href: action.link,
                autoFocus: index === 0 && isTriggeredUsingKeyboard
            }, action.label, isKudos && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.KudosBlobAnimation), null))));
            if (isKudos) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimatedKudosButton), {
                key: `profile-card-action-kudos_${action.id || index}`
            }, button);
            return button;
        }), overflowActions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jHIf5.OverflowProfileCardButtons), {
            actions: overflowActions,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration,
            onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD))
        }));
    };
    const $4585e7f6ae851e43$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
        (0, $5uXOq.useEffect)(()=>{
            fireAnalyticsWithDuration((duration)=>(0, $ivXTE.profileCardRendered)('user', 'spinner', {
                    duration: duration
                }));
        }, [
            fireAnalyticsWithDuration
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), {
            "data-testid": "profilecard-spinner-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
    var $4585e7f6ae851e43$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($4585e7f6ae851e43$export$64e0275ede8ab792);
});
parcelRegister("jHIf5", function(module, exports) {
    $parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", ()=>$c3d6d65db2db7a42$export$3e2419a7546ad45e);
    $parcel$export(module.exports, "OverflowProfileCardButtons", ()=>$c3d6d65db2db7a42$export$9d9b53d23c0df7a1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $9yOBd;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $c3d6d65db2db7a42$export$3e2419a7546ad45e = 2;
    const $c3d6d65db2db7a42$export$9d9b53d23c0df7a1 = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [, setOpen] = (0, $5uXOq.useState)(false);
        const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
        const numActions = actions.length + $c3d6d65db2db7a42$export$3e2419a7546ad45e;
        const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: nextOpen })=>{
            setOpen((prevOpen)=>{
                if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $ivXTE.moreActionsClicked)('user', {
                        duration: duration,
                        numActions: numActions
                    }));
                return nextOpen;
            });
        }, [
            numActions,
            fireAnalyticsWithDuration
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.OverflowActionButtonsWrapper), {
            "data-testid": "profilecard-actions-overflow"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            onOpenChange: onOpenChange,
            placement: 'bottom-end',
            trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                    type: "button",
                    ...providedProps,
                    ref: triggerRef,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intl.formatMessage((0, $9MMkr.default).profileCardMoreIconLabel)
                    })
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, actions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: action.id,
                onClick: (event, ...args)=>{
                    onItemClick(action, args, event, index);
                },
                href: action.link
            }, action.label)))));
    };
});
parcelRegister("cfBc7", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardDetails", ()=>$5c33ece4bf360f1e$export$c0e6870b898eb99d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $lj8SI;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $hljsi = parcelRequire("hljsi");
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    parcelRequire("kyz3w");
    var $kXUaX = parcelRequire("kXUaX");
    var $htJ3O = parcelRequire("htJ3O");
    const $5c33ece4bf360f1e$var$detailedListWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0',
        padding: 'space.0'
    });
    const $5c33ece4bf360f1e$var$fullNameLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '18px',
        fontWeight: '400',
        letterSpacing: 'normal',
        lineHeight: `${24 / 18}em`
    });
    const $5c33ece4bf360f1e$var$noMetaLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.400',
        marginRight: '0',
        marginBottom: 'space.150',
        marginLeft: '0'
    });
    const $5c33ece4bf360f1e$var$metaLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.150',
        marginRight: '0',
        marginBottom: '0',
        marginLeft: '0'
    });
    const $5c33ece4bf360f1e$var$disabledAccountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text'
    });
    const $5c33ece4bf360f1e$var$activeAccountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.inverse'
    });
    const $5c33ece4bf360f1e$var$renderName = (nickname, fullName, meta)=>{
        if (!fullName && !nickname) return null;
        const isNicknameRedundant = !nickname || nickname === fullName;
        const shownNickname = ` (${nickname}) `;
        const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5c33ece4bf360f1e$var$fullNameLabelStyles,
                $5c33ece4bf360f1e$var$activeAccountStyles,
                meta ? $5c33ece4bf360f1e$var$metaLabelStyles : $5c33ece4bf360f1e$var$noMetaLabelStyles
            ],
            testId: "profilecard-name",
            id: "profilecard-name-label"
        }, displayName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.FullNameLabel), {
            noMeta: !meta,
            "data-testid": "profilecard-name",
            id: "profilecard-name-label"
        }, displayName);
    };
    const $5c33ece4bf360f1e$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
        if (disabledAccountMessage) return disabledAccountMessage;
        const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
        const relativeDateKey = (0, $hljsi.default)(date);
        const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
        const secondSentence = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default)[msgKey]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            testId: "profilecard-disabled-account"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).generalDescMsgForDisabledUser), " ", secondSentence);
    };
    const $5c33ece4bf360f1e$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
        if (lozenges.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CustomLozengeContainer), null, lozenges.map(({ text: text, ...otherProps }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                ...otherProps,
                key: index
            }, text)));
    };
    const $5c33ece4bf360f1e$var$BotProfileCardDetails = (props)=>{
        const { fullName: fullName, nickname: nickname } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, $5c33ece4bf360f1e$var$renderName(nickname, fullName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AppTitleLabel), null, "App"));
    };
    const $5c33ece4bf360f1e$var$DisabledProfileCardDetails = (props)=>{
        const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
        const name = status === 'inactive' ? fullName || nickname : nickname || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).disabledAccountDefaultName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5c33ece4bf360f1e$var$fullNameLabelStyles,
                $5c33ece4bf360f1e$var$noMetaLabelStyles,
                $5c33ece4bf360f1e$var$disabledAccountStyles
            ],
            testId: "profilecard-name",
            id: "profilecard-name-label"
        }, name) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.FullNameLabel), {
            noMeta: true,
            isDisabledAccount: true,
            "data-testid": "profilecard-name",
            id: "profilecard-name-label"
        }, name), hasDisabledAccountLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.LozengeWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "default",
            isBold: true
        }, status === 'inactive' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).inactiveAccountMsg) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).closedAccountMsg))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DisabledInfo), null, $5c33ece4bf360f1e$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "companyName"
        }, companyName));
    };
    const $5c33ece4bf360f1e$export$c0e6870b898eb99d = (props)=>{
        const { meta: meta, status: status } = props;
        if (props.isBot) return (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$BotProfileCardDetails, props);
        if (status === 'inactive' || status === 'closed') return (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$DisabledProfileCardDetails, {
            ...props,
            status: status
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, $5c33ece4bf360f1e$var$renderName(props.nickname, props.fullName, meta), meta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.JobTitleLabel), null, meta), (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$CustomLozenges, {
            lozenges: props.customLozenges
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "dl",
            xcss: $5c33ece4bf360f1e$var$detailedListWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "email"
        }, props.email), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "time"
        }, props.timestring), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "companyName"
        }, props.companyName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "location"
        }, props.location)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $htJ3O.default), {
            reportingLines: props.reportingLines,
            reportingLinesProfileUrl: props.reportingLinesProfileUrl,
            onReportingLinesClick: props.onReportingLinesClick,
            fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
        }));
    };
});
parcelRegister("hljsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a208e25df4a65e86$export$2e2bcd8739ae039);
    var $kMWS1;
    var $f0lG8;
    var $ki4Ey;
    var $jovBr;
    function $a208e25df4a65e86$export$c03bb0116ee09d4b(date, today = new Date()) {
        return !!date.getTime && (0, (0, parcelRequire("jovBr")).default)(date) && date.getTime() <= today.getTime();
    }
    function $a208e25df4a65e86$export$2e2bcd8739ae039(date, today = new Date()) {
        if (!date || !$a208e25df4a65e86$export$c03bb0116ee09d4b(date, today)) return null;
        if ((0, (0, parcelRequire("ki4Ey")).default)(date)) return 'ThisWeek';
        if ((0, (0, parcelRequire("f0lG8")).default)(date)) return 'ThisMonth';
        if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
        const diffInMonths = (0, (0, parcelRequire("kMWS1")).default)(today, date);
        if (diffInMonths < 6) return 'AFewMonths';
        if (diffInMonths <= 12) return 'SeveralMonths';
        return 'MoreThanAYear';
    }
});
parcelRegister("kyz3w", function(module, exports) {
    $parcel$export(module.exports, "IconLabel", ()=>(parcelRequire("kXUaX")).default);
    var $kXUaX = parcelRequire("kXUaX");
});
parcelRegister("kXUaX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd3f55567e0e46d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8yYK6;
    var $aVnO1;
    var $cKlYO;
    var $jRceo;
    var $jnj6z = parcelRequire("jnj6z");
    const $9fd3f55567e0e46d$var$icons = {
        location: (0, ($parcel$interopDefault((0, parcelRequire("cKlYO"))))),
        time: (0, ($parcel$interopDefault((0, parcelRequire("8yYK6"))))),
        email: (0, ($parcel$interopDefault((0, parcelRequire("aVnO1"))))),
        companyName: (0, ($parcel$interopDefault((0, parcelRequire("jRceo")))))
    };
    class $9fd3f55567e0e46d$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                icon: ''
            };
        }
        render() {
            if (!this.props.children) return null;
            const IconElement = this.props.icon && $9fd3f55567e0e46d$var$icons[this.props.icon];
            const displayIcon = IconElement ? (0, ($parcel$interopDefault($5uXOq))).createElement(IconElement, {
                label: `${this.props.icon}`,
                LEGACY_size: "small",
                color: "currentColor"
            }) : null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabel), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabelIcon), {
                as: "dt"
            }, displayIcon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabelText), {
                as: "dd"
            }, this.props.children));
        }
    }
});
parcelRegister("8yYK6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63c09dee2c4be134$var$_react = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63c09dee2c4be134$var$_clock = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("hyKRO")));
    var $63c09dee2c4be134$var$_recent = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5IlYG")));
    function $63c09dee2c4be134$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63c09dee2c4be134$var$ClockIcon = (props)=>$63c09dee2c4be134$var$_react.default.createElement($63c09dee2c4be134$var$_clock.default, Object.assign({
            LEGACY_fallbackIcon: $63c09dee2c4be134$var$_recent.default
        }, props));
    $63c09dee2c4be134$var$ClockIcon.Name = 'ClockIconMigration';
    var $63c09dee2c4be134$var$_default = module.exports.default = $63c09dee2c4be134$var$ClockIcon;
});
parcelRegister("aVnO1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));
    var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
    function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f41b19bed4136e0$var$EmailIcon = (props)=>$7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
            LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
        }, props));
    $7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
    var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;
});
parcelRegister("eRB05", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ad22b76beceec928$var$_UNSAFE_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ad22b76beceec928$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ad22b76beceec928$var$EmailIcon = (props)=>$ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
        }, props));
    $ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
    var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;
});
parcelRegister("5bEkJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
    function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3c6d443366bf8cbb$var$EmailIcon = (props)=>$3c6d443366bf8cbb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
        }, props, {
            newIcon: $3c6d443366bf8cbb$var$_email.default
        }));
    $3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
    var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;
});
parcelRegister("cKlYO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $947ad4a84d881cd0$var$_react = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $947ad4a84d881cd0$var$_location = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("d3xMd")));
    var $947ad4a84d881cd0$var$_location2 = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("773gM")));
    function $947ad4a84d881cd0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $947ad4a84d881cd0$var$LocationIcon = (props)=>$947ad4a84d881cd0$var$_react.default.createElement($947ad4a84d881cd0$var$_location.default, Object.assign({
            LEGACY_fallbackIcon: $947ad4a84d881cd0$var$_location2.default
        }, props));
    $947ad4a84d881cd0$var$LocationIcon.Name = 'LocationIconMigration';
    var $947ad4a84d881cd0$var$_default = module.exports.default = $947ad4a84d881cd0$var$LocationIcon;
});
parcelRegister("d3xMd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9815c17f4ba43822$var$_react = $9815c17f4ba43822$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9815c17f4ba43822$var$_UNSAFE_baseNew = $9815c17f4ba43822$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9815c17f4ba43822$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9815c17f4ba43822$var$LocationIcon = (props)=>$9815c17f4ba43822$var$_react.default.createElement($9815c17f4ba43822$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
        }, props));
    $9815c17f4ba43822$var$LocationIcon.displayName = 'LocationIcon';
    var $9815c17f4ba43822$var$_default = module.exports.default = $9815c17f4ba43822$var$LocationIcon;
});
parcelRegister("773gM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $52dbb9250ec5d302$var$_react = $52dbb9250ec5d302$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $52dbb9250ec5d302$var$_location = $52dbb9250ec5d302$var$_interopRequireDefault((parcelRequire("d3xMd")));
    function $52dbb9250ec5d302$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $52dbb9250ec5d302$var$LocationIcon = (props)=>$52dbb9250ec5d302$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
        }, props, {
            newIcon: $52dbb9250ec5d302$var$_location.default
        }));
    $52dbb9250ec5d302$var$LocationIcon.displayName = 'LocationIcon';
    var $52dbb9250ec5d302$var$_default = module.exports.default = $52dbb9250ec5d302$var$LocationIcon;
});
parcelRegister("jRceo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e74c746303d0418a$var$_react = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e74c746303d0418a$var$_officeBuilding = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    var $e74c746303d0418a$var$_officeBuilding2 = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("icDh5")));
    function $e74c746303d0418a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e74c746303d0418a$var$OfficeBuildingIcon = (props)=>$e74c746303d0418a$var$_react.default.createElement($e74c746303d0418a$var$_officeBuilding.default, Object.assign({
            LEGACY_fallbackIcon: $e74c746303d0418a$var$_officeBuilding2.default
        }, props));
    $e74c746303d0418a$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
    var $e74c746303d0418a$var$_default = module.exports.default = $e74c746303d0418a$var$OfficeBuildingIcon;
});
parcelRegister("4bTdk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30d304d6d8375db3$var$_UNSAFE_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $30d304d6d8375db3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>$30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
        }, props));
    $30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;
});
parcelRegister("icDh5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d407d01834f2f44a$var$_react = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d407d01834f2f44a$var$_officeBuilding = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    function $d407d01834f2f44a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d407d01834f2f44a$var$OfficeBuildingIcon = (props)=>$d407d01834f2f44a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
        }, props, {
            newIcon: $d407d01834f2f44a$var$_officeBuilding.default
        }));
    $d407d01834f2f44a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $d407d01834f2f44a$var$_default = module.exports.default = $d407d01834f2f44a$var$OfficeBuildingIcon;
});
parcelRegister("htJ3O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7034dd6b25e87bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $ujWmd;
    var $jnhNB;
    var $fVnbM;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $9MMkr = parcelRequire("9MMkr");
    var $aLmg4 = parcelRequire("aLmg4");
    var $ivXTE = parcelRequire("ivXTE");
    function $b7034dd6b25e87bb$var$getProfileHref(userId, profileUrl) {
        return profileUrl ? profileUrl + userId : undefined;
    }
    const $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: 'font.heading.xxsmall',
        fontWeight: 600,
        marginBottom: 'space.100'
    });
    const $b7034dd6b25e87bb$var$reportingLinesHeadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: '0'
    });
    const $b7034dd6b25e87bb$var$ReportingLinesDetails = (props)=>{
        const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
        const { managers: managers = [], reports: reports = [] } = reportingLines;
        const manager = managers.length >= 1 ? managers[0] : undefined;
        const hasReports = reports.length > 0;
        const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
                fireAnalyticsWithDuration((duration)=>(0, $ivXTE.reportingLinesClicked)({
                        duration: duration,
                        userType: userType
                    }));
                onReportingLinesClick(user);
            } : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, manager && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesSection), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles,
                $b7034dd6b25e87bb$var$reportingLinesHeadingStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).managerSectionHeading)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesHeading), {
            style: {
                marginBottom: 0
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).managerSectionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.OffsetWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            href: $b7034dd6b25e87bb$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
            onClick: getReportingLinesOnClick(manager, 'manager'),
            isDisabled: !onReportingLinesClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ManagerSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: manager.pii?.picture
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ManagerName), null, manager.pii?.name))))), hasReports && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesSection), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).directReportsSectionHeading)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesHeading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).directReportsSectionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            size: "small",
            data: reports.map((member)=>{
                return {
                    key: member.accountIdentifier,
                    name: member.pii?.name || '',
                    src: member.pii?.picture,
                    href: $b7034dd6b25e87bb$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                    onClick: getReportingLinesOnClick(member, 'direct-report')
                };
            }),
            maxCount: 5,
            testId: "profilecard-reports-avatar-group"
        })));
    };
    var $b7034dd6b25e87bb$export$2e2bcd8739ae039 = $b7034dd6b25e87bb$var$ReportingLinesDetails;
});
parcelRegister("aLmg4", function(module, exports) {
    $parcel$export(module.exports, "ReportingLinesSection", ()=>$feff5fbdc7496043$export$ae48ddd79a45b949);
    $parcel$export(module.exports, "ReportingLinesHeading", ()=>$feff5fbdc7496043$export$abdd342d30bb5b5f);
    $parcel$export(module.exports, "ManagerSection", ()=>$feff5fbdc7496043$export$2992b481dad9fb03);
    $parcel$export(module.exports, "ManagerName", ()=>$feff5fbdc7496043$export$98f8ec89e658b052);
    $parcel$export(module.exports, "OffsetWrapper", ()=>$feff5fbdc7496043$export$56eae56612ce5f3);
    var $k5uoT;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $feff5fbdc7496043$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $feff5fbdc7496043$export$ae48ddd79a45b949 = (0, $bWGt6.default)("div", {
        target: "e11fux8a4"
    })({
        name: "1m5erzj",
        styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$abdd342d30bb5b5f = (0, $bWGt6.default)("h3", {
        target: "e11fux8a3"
    })({
        color: (0, $huHkE.appLabelTextColor),
        fontSize: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 1.5}px`,
        fontWeight: 600,
        marginBottom: "var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$2992b481dad9fb03 = (0, $bWGt6.default)("div", {
        target: "e11fux8a2"
    })({
        display: 'flex',
        alignItems: 'center',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $feff5fbdc7496043$export$98f8ec89e658b052 = (0, $bWGt6.default)("span", {
        target: "e11fux8a1"
    })({
        fontSize: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 1.5}px`,
        marginLeft: "var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$56eae56612ce5f3 = (0, $bWGt6.default)("div", {
        target: "e11fux8a0"
    })({
        name: "ysolxb",
        styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
    });
});
parcelRegister("d4FHw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e50495f0c6da843b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $adIkV;
    var $gH4E9;
    var $4sfdL = parcelRequire("4sfdL");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $lrMir = parcelRequire("lrMir");
    var $ifxzB = parcelRequire("ifxzB");
    class $e50495f0c6da843b$var$ProfileCardResourced extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                actions: []
            };
        }
        componentDidMount() {
            this._isMounted = true;
            this.clientFetchProfile();
        }
        componentDidUpdate(prevProps) {
            const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
            if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
                isLoading: undefined
            }, this.clientFetchProfile);
        }
        componentWillUnmount() {
            this._isMounted = false;
        }
        handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: false,
                data: profileData,
                reportingLinesData: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            });
        }
        handleClientError(err) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: true,
                error: err
            });
        }
        render() {
            const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled, teamCentralBaseUrl: teamCentralBaseUrl } = this.state;
            const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
            const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
            if (isFetchingOrNotStartToFetchYet) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ifxzB.default), {
                fireAnalytics: this.fireAnalytics
            }));
            else if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
                "data-testid": "profile-card-resourced-error-state"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
                errorType: error,
                reload: this.clientFetchProfile,
                fireAnalytics: this.fireAnalytics
            }));
            const newProps = {
                hasError: hasError,
                errorType: error,
                clientFetchProfile: this.clientFetchProfile,
                reportingLines: reportingLinesData,
                onReportingLinesClick: onReportingLinesClick,
                cloudId: cloudId,
                userId: userId,
                addFlag: addFlag,
                ...data,
                isKudosEnabled: isKudosEnabled,
                teamCentralBaseUrl: teamCentralBaseUrl,
                openKudosDrawer: this.openKudosDrawer
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isKudosEnabled && newProps.teamCentralBaseUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
                isOpen: this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, (0, parcelRequire("gH4E9")).KudosType).INDIVIDUAL,
                    recipientId: this.props.userId
                },
                analyticsSource: "profile-card",
                teamCentralBaseUrl: newProps.teamCentralBaseUrl,
                cloudId: this.props.cloudId,
                addFlag: this.props.addFlag,
                onClose: this.closeKudosDrawer
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lrMir.default), {
                ...newProps,
                actions: this.filterActions()
            })));
        }
        constructor(...args){
            super(...args);
            this._isMounted = false;
            this.state = {
                visible: false,
                isLoading: undefined,
                hasError: false,
                error: null,
                data: null,
                reportingLinesData: undefined,
                isKudosEnabled: false,
                kudosDrawerOpen: false,
                teamCentralBaseUrl: undefined
            };
            this.fireAnalytics = (payload)=>{
                if (!this._isMounted) return;
                if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
            };
            this.clientFetchProfile = ()=>{
                const { cloudId: cloudId, userId: userId } = this.props;
                const { isLoading: isLoading } = this.state;
                if (isLoading === true) return;
                this.setState({
                    isLoading: true,
                    hasError: false,
                    data: null
                }, ()=>{
                    const requests = Promise.all([
                        this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                        this.props.resourceClient.getReportingLines(userId),
                        this.props.resourceClient.shouldShowGiveKudos(),
                        this.props.resourceClient.getTeamCentralBaseUrl({
                            withOrgContext: true,
                            withSiteContext: true
                        })
                    ]);
                    requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
                });
            };
            this.filterActions = ()=>(0, $4sfdL.default)(this.props.actions, this.state.data);
            this.openKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: true
                });
            };
            this.closeKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: false
                });
            };
        }
    }
    const $e50495f0c6da843b$export$a6d9ff68ecba3be5 = $e50495f0c6da843b$var$ProfileCardResourced;
    var $e50495f0c6da843b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($e50495f0c6da843b$var$ProfileCardResourced);
});
parcelRegister("ifxzB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44786ae639641a68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
        (0, $5uXOq.useEffect)(()=>{
            fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
        }, [
            fireAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
    var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;
});
parcelRegister("264zF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74b3c02273951832$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $adIkV;
    var $gH4E9;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $4sfdL = parcelRequire("4sfdL");
    var $chprS = parcelRequire("chprS");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    var $kDbj5 = parcelRequire("kDbj5");
    var $dYuIx = parcelRequire("dYuIx");
    var $ifxzB = parcelRequire("ifxzB");
    function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
        if (isAgent && (0, (0, parcelRequire("VSDnB")).fg)('enable_agent_profile_card')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kDbj5.AgentProfileCardResourced), {
            accountId: userId,
            cloudId: cloudId,
            resourceClient: resourceClient,
            viewingUserId: viewingUserId,
            trigger: trigger,
            product: product,
            onChatClick: agentActions?.onChatClick,
            onConversationStartersClick: agentActions?.onConversationStartersClick,
            addFlag: addFlag
        });
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        }));
    }
    function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isMounted = (0, $5uXOq.useRef)(false);
        const showDelay = trigger === 'click' ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
        const hideDelay = trigger === 'click' ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
        const showTimer = (0, $5uXOq.useRef)(0);
        const hideTimer = (0, $5uXOq.useRef)(0);
        const [visible, setVisible] = (0, $5uXOq.useState)(false);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
        const [hasError, setHasError] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [data, setData] = (0, $5uXOq.useState)(null);
        const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
        const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
        const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
        const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
        const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
        const triggerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            setIsLoading(undefined);
            setHasError(false);
            setError(null);
            setData(null);
            setReportingLinesData(undefined);
            setShouldShowGiveKudos(false);
            setTeamCentralBaseUrl(undefined);
        }, [
            userId
        ]);
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (!isMounted.current) return;
            (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
                onVisibilityChange && onVisibilityChange(false);
            }, hideDelay);
        }, [
            hideDelay,
            isTriggeredUsingKeyboard,
            onVisibilityChange
        ]);
        const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
            if (event.key && event.key !== 'Escape') return;
            if (triggerRef.current) triggerRef.current.focus();
            setTriggeredUsingKeyboard(false);
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, [
            setTriggeredUsingKeyboard,
            setVisible,
            onVisibilityChange
        ]);
        const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
            if (!isMounted.current) return;
            setIsLoading(false);
            setHasError(false);
            setData(profileData);
            setReportingLinesData(reportingLinesData);
            setTeamCentralBaseUrl(teamCentralBaseUrl);
            setShouldShowGiveKudos(shouldShowGiveKudos);
        }, [
            setHasError,
            setIsLoading,
            setData,
            setReportingLinesData,
            setShouldShowGiveKudos
        ]);
        const handleClientError = (0, $5uXOq.useCallback)((err)=>{
            if (!isMounted.current) return;
            setIsLoading(false);
            setHasError(true);
            setError(err);
        }, [
            setHasError,
            setIsLoading,
            setError
        ]);
        const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
            if (isLoading === true) return;
            setIsLoading(true);
            setHasError(false);
            setError(null);
            setData(null);
            try {
                const requests = Promise.all([
                    resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                    resourceClient.getReportingLines(userId),
                    resourceClient.shouldShowGiveKudos(),
                    resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                const responses = await requests;
                handleClientSuccess(...responses);
            } catch (err) {
                handleClientError(err);
            }
        }, [
            cloudId,
            fireAnalytics,
            isLoading,
            resourceClient,
            userId,
            handleClientSuccess,
            handleClientError
        ]);
        const showProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    clientFetchProfile();
                    setVisible(true);
                    onVisibilityChange && onVisibilityChange(true);
                }
            }, showDelay);
        }, [
            showDelay,
            visible,
            clientFetchProfile,
            onVisibilityChange
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setTriggeredUsingKeyboard(true);
                showProfilecard();
                if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
            }
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onBlur: hideProfilecard,
                onKeyPress: onKeyPress
            } : {
                onClick: onClick,
                onKeyPress: onKeyPress
            }, [
            hideProfilecard,
            onClick,
            onKeyPress,
            onMouseEnter,
            trigger
        ]);
        const filterActions = (0, $5uXOq.useCallback)(()=>{
            return (0, $4sfdL.default)(actions, data);
        }, [
            actions,
            data
        ]);
        const openKudosDrawer = ()=>{
            hideProfilecard();
            setKudosDrawerOpen(true);
        };
        const closeKudosDrawer = ()=>{
            setKudosDrawerOpen(false);
        };
        const showLoading = isLoading === true || isLoading === undefined;
        const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: onFocus
            } : {}, [
            hideProfilecard,
            onFocus,
            onMouseEnter,
            trigger
        ]);
        const profilecardProps = {
            userId: userId,
            fullName: prepopulatedData?.fullName,
            isCurrentUser: userId === viewingUserId,
            clientFetchProfile: clientFetchProfile,
            ...data,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            isKudosEnabled: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            openKudosDrawer: openKudosDrawer,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            disabledAriaAttributes: disabledAriaAttributes
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!visible,
            onClose: (event)=>{
                hideProfilecard();
                handleKeyboardClose(event);
            },
            placement: position,
            offset: offset ?? [
                0,
                8
            ],
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", wrapperProps, showLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement($74b3c02273951832$var$LoadingView, {
                    fireAnalytics: fireAnalytics
                }) : visible && (0, ($parcel$interopDefault($5uXOq))).createElement($74b3c02273951832$var$ProfileCardContent, {
                    profilecardProps: profilecardProps,
                    isAgent: !!data?.isAgent,
                    userId: userId,
                    cloudId: cloudId,
                    resourceClient: resourceClient,
                    viewingUserId: viewingUserId,
                    trigger: trigger,
                    product: product,
                    profileCardAction: filterActions(),
                    errorType: error,
                    hasError: hasError,
                    agentActions: agentActions,
                    addFlag: addFlag
                })),
            trigger: (triggerProps)=>{
                const { ref: callbackRef, ...innerProps } = triggerProps;
                const ref = (element)=>{
                    triggerRef.current = element;
                    if (typeof callbackRef === 'function') callbackRef(element);
                };
                const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ...containerListeners,
                    ref: ref,
                    "data-testid": testId,
                    "aria-labelledby": ariaLabelledBy,
                    ...disabledAriaAttributes ? {} : {
                        role: 'button',
                        tabIndex: 0,
                        'aria-label': (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                    }
                }, children);
            },
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: autoFocus ?? trigger === 'click',
            shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
        }), shouldShowGiveKudos && teamCentralBaseUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
            isOpen: kudosDrawerOpen,
            recipient: {
                type: (0, (0, parcelRequire("gH4E9")).KudosType).INDIVIDUAL,
                recipientId: userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            addFlag: addFlag,
            onClose: closeKudosDrawer
        })));
    }
    const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
            "data-testId": "profilecard.profilecardtrigger.loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        }));
});
parcelRegister("chprS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b051cf4c3ebf799$export$2e2bcd8739ae039);
    var $7VHMR;
    const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
        if (ariaLabelProp) return ariaLabelProp;
        return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
            fullName: fullName
        }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
    };
    const $4b051cf4c3ebf799$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fallbackLabel: {
            id: 'profilecard.user.trigger.fallback-aria-label',
            defaultMessage: 'More information about this user',
            description: 'Label for profile card trigger when we do not have user name'
        },
        label: {
            id: 'profilecard.user.trigger.aria-label',
            defaultMessage: 'More information about {fullName}',
            description: 'Label for profile card trigger'
        }
    });
    var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;
});
parcelRegister("kDbj5", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardResourced", ()=>$9f87d208f89c63eb$export$4b013ffffcb40af8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $ivXTE = parcelRequire("ivXTE");
    var $dG58U = parcelRequire("dG58U");
    var $cI0Td = parcelRequire("cI0Td");
    var $a3FJs = parcelRequire("a3FJs");
    var $iwWWV = parcelRequire("iwWWV");
    const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
        const [agentData, setAgentData] = (0, $5uXOq.useState)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
            agentData?.creator_type,
            agentData?.creator
        ]);
        const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
            if (!creator) return undefined;
            switch(creator_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    try {
                        if (!creatorUserId || !props.cloudId) return undefined;
                        const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                        return {
                            type: 'CUSTOMER',
                            name: creatorInfo.fullName,
                            profileLink: `/people/${creatorUserId}`,
                            id: creatorUserId
                        };
                    } catch (error) {
                        return undefined;
                    }
                default:
                    return undefined;
            }
        }, [
            creatorUserId,
            fireAnalytics,
            props.cloudId,
            props.resourceClient
        ]);
        const getAgentInfo = (0, $5uXOq.useCallback)(()=>{
            return props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
        }, [
            fireAnalytics,
            props.accountId,
            props.resourceClient
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            setIsLoading(true);
            const getAgentData = async ()=>{
                const profileData = await getAgentInfo();
                const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
                return {
                    ...profileData,
                    creatorInfo: agentCreatorInfo
                };
            };
            const agentData = await getAgentData();
            setAgentData(agentData);
            setIsLoading(false);
        }, [
            getAgentInfo,
            getCreator
        ]);
        (0, $5uXOq.useEffect)(()=>{
            try {
                fetchData();
            } catch (error) {
                setIsLoading(false);
                setError(error);
            }
        }, [
            fetchData,
            getAgentInfo,
            getCreator,
            props.accountId,
            props.cloudId,
            props.resourceClient
        ]);
        if (error || !isLoading && !agentData) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        }));
        if (agentData) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        });
        return null;
    };
});
parcelRegister("dG58U", function(module, exports) {
    $parcel$export(module.exports, "getAAIDFromARI", ()=>$dd4eeae2be471029$export$3761e66a04602cbd);
    const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
    const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
        return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
    };
});
parcelRegister("iwWWV", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardLazy", ()=>$b487397875f853f0$export$ed0ca9c1d49ea0bf);
    var $5uXOq = parcelRequire("5uXOq");
    const $b487397875f853f0$export$ed0ca9c1d49ea0bf = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("9gV7o"))));
});
parcelRegister("dYuIx", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardLazy", ()=>$78b4a66e55984f2d$export$403d297463f226af);
    var $5uXOq = parcelRequire("5uXOq");
    const $78b4a66e55984f2d$export$403d297463f226af = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lrMir"))));
});
parcelRegister("iMLpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70b57d5fcda0f9a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    function $70b57d5fcda0f9a2$export$2e2bcd8739ae039(Component) {
        return class WithOuterListeners extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            componentDidMount() {
                if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
                if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
            }
            componentWillUnmount() {
                if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
                if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, this.props);
            }
            constructor(...args){
                super(...args);
                this.handleClick = (evt)=>{
                    const { handleClickOutside: handleClickOutside } = this.props;
                    if (handleClickOutside) {
                        const domNode = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
                        if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                    }
                };
                this.handleKeydown = (evt)=>{
                    const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                    if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
                };
            }
        };
    }
});
parcelRegister("5uVl7", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardTrigger", ()=>$50f554e79ae2423e$export$64983741fea6a45d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $ivXTE = parcelRequire("ivXTE");
    var $dG58U = parcelRequire("dG58U");
    var $3j5Lk = parcelRequire("3j5Lk");
    var $iwWWV = parcelRequire("iwWWV");
    const $50f554e79ae2423e$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
        const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const getCreator = async (creator_type, creator)=>{
            if (!creator) return undefined;
            switch(creator_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'FORGE':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    const userId = (0, $dG58U.getAAIDFromARI)(creator) || '';
                    try {
                        if (!userId || !cloudId) return undefined;
                        const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                        return {
                            type: 'CUSTOMER',
                            name: creatorInfo.fullName,
                            profileLink: `/people/${userId}`,
                            id: userId
                        };
                    } catch (error) {
                        return undefined;
                    }
                default:
                    return undefined;
            }
        };
        const fetchAgentProfile = async ()=>{
            const agentInfo = await resourceClient.getRovoAgentProfile({
                type: 'agent',
                value: userId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
            return {
                ...agentInfo,
                creatorInfo: agentCreatorInfo
            };
        };
        const renderProfileCard = ({ profileData: profileData, error: error })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iwWWV.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                isCreatedByViewingUser: profileData?.creatorInfo && profileData?.creatorInfo?.id === viewingUserId,
                cloudId: props.cloudId,
                product: product,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                addFlag: props.addFlag
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3j5Lk.default), {
            ...props,
            trigger: "hover",
            renderProfileCard: renderProfileCard,
            fetchProfile: fetchAgentProfile,
            fireAnalytics: fireAnalytics,
            profileCardType: "agent"
        });
    };
});
parcelRegister("3j5Lk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16aed3e91811a6aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $k5uoT;
    var $ivXTE = parcelRequire("ivXTE");
    var $hHa0v = parcelRequire("hHa0v");
    var $8qsT1 = parcelRequire("8qsT1");
    var $iRPRU = parcelRequire("iRPRU");
    var $glChS = parcelRequire("glChS");
    const $16aed3e91811a6aa$var$DELAY_MS_SHOW = 800;
    const $16aed3e91811a6aa$var$DELAY_MS_HIDE = 200;
    function $16aed3e91811a6aa$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
        const showDelay = trigger === 'click' ? 0 : $16aed3e91811a6aa$var$DELAY_MS_SHOW;
        const hideDelay = trigger === 'click' ? 0 : $16aed3e91811a6aa$var$DELAY_MS_HIDE;
        const showTimer = (0, $5uXOq.useRef)(0);
        const hideTimer = (0, $5uXOq.useRef)(0);
        const [visible, setVisible] = (0, $5uXOq.useState)(false);
        const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $hHa0v.useProfileInfo)({
            fetchUserProfile: fetchProfile
        });
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        }, []);
        const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
            }, hideDelay);
        }, [
            hideDelay
        ]);
        const showProfilecard = (0, $5uXOq.useCallback)(async ()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    getProfileData?.();
                    setVisible(true);
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.cardTriggered)(profileCardType, trigger));
                }
            }, showDelay);
        }, [
            showDelay,
            visible,
            getProfileData,
            fireAnalytics,
            profileCardType,
            trigger
        ]);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            ...popupProps,
            isOpen: !!visible,
            onClose: hideProfilecard,
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: popupProps.autoFocus ?? trigger === 'click',
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldFitContainer: false,
            trigger: (triggerProps)=>{
                const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iRPRU.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger
                });
            },
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: hideProfilecard,
                    onFocus: showProfilecard
                }, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $glChS.ProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8qsT1.LoadingState), {
                    fireAnalytics: fireAnalytics,
                    profileType: profileCardType
                })) : renderProfileCard({
                    profileData: profileData,
                    error: error
                }))
        });
    }
    var $16aed3e91811a6aa$export$2e2bcd8739ae039 = $16aed3e91811a6aa$var$ProfileCardTrigger;
});
parcelRegister("hHa0v", function(module, exports) {
    $parcel$export(module.exports, "useProfileInfo", ()=>$1015119dde638e8f$export$6cace87f7d7a9738);
    var $5uXOq = parcelRequire("5uXOq");
    const $1015119dde638e8f$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [profileData, setProfileData] = (0, $5uXOq.useState)();
        const getProfileData = async ()=>{
            setIsLoading(true);
            try {
                const profileData = await fetchUserProfile?.();
                setProfileData(profileData);
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };
        return {
            profileData: profileData,
            isLoading: isLoading,
            error: error,
            getProfileData: getProfileData
        };
    };
});
parcelRegister("iRPRU", function(module, exports) {
    $parcel$export(module.exports, "PopupTrigger", ()=>$eb07ae3447684674$export$95d4acdbab2fc6ef);
    var $5uXOq = parcelRequire("5uXOq");
    const $eb07ae3447684674$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                showProfilecard();
            }
        }, [
            showProfilecard
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onBlur: hideProfilecard,
                onKeyPress: onKeyPress
            } : {
                onClick: onClick,
                onKeyPress: onKeyPress
            }, [
            hideProfilecard,
            onClick,
            onKeyPress,
            onMouseEnter,
            trigger
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props,
            ...containerListeners,
            ref: ref,
            "aria-labelledby": ariaLabelledBy
        }, children);
    };
    const $eb07ae3447684674$export$95d4acdbab2fc6ef = (0, ($parcel$interopDefault($5uXOq))).forwardRef($eb07ae3447684674$var$PopupTriggerInner);
});
parcelRegister("glChS", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardWrapper", ()=>$fc69b6eef7bac459$export$59abd6feb7dc8540);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $fc69b6eef7bac459$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '360px'
    });
    const $fc69b6eef7bac459$export$59abd6feb7dc8540 = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $fc69b6eef7bac459$var$styles
        }, children);
    };
});
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $cb25w;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("cb25w")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("ih2j7", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardLegacyWrapper", ()=>$69aea63e0704566b$export$6ef7d4845cf112be);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $4oNEb;
    var $t1z25;
    const $69aea63e0704566b$var$parsePopperOffsetValue = (offset)=>{
        let offsetArray = [
            0,
            0
        ];
        if ((0, ($parcel$interopDefault($gccSB)))(offset)) return offsetArray;
        if (typeof offset === 'string') offsetArray = offset.split(',').map((pxValue)=>parseInt(pxValue.replace('px', ''), 10));
        else if (Array.isArray(offset) && offset.length === 2) offsetArray = offset;
        return offsetArray.some(Number.isNaN) ? [
            0,
            0
        ] : offsetArray;
    };
    const $69aea63e0704566b$export$6ef7d4845cf112be = ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, referenceElement: referenceElement, offset: offset, children: children, placement: placement })=>{
        const offsetTuple = $69aea63e0704566b$var$parsePopperOffsetValue(offset);
        const modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offsetTuple
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    tether: true
                }
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), {
            referenceElement: referenceElement,
            placement: placement || (0, (0, parcelRequire("t1z25")).getPlacement)(referenceElement),
            modifiers: modifiers
        }, ({ ref: ref, style: style, forceUpdate: forceUpdate })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "profilecard-next.common.ui.legacy-profile-card.div",
                ref: ref,
                style: {
                    ...style
                },
                onMouseLeave: onMouseLeave,
                onMouseEnter: onMouseEnter
            }, children(forceUpdate)));
    };
});
parcelRegister("t1z25", function(module, exports) {
    $parcel$export(module.exports, "useEventListener", ()=>$3bdcead9d38aaa77$export$7080b3e976bc91ab);
    $parcel$export(module.exports, "useHideProfileCardDelayed", ()=>$3bdcead9d38aaa77$export$30416a530a92ed77);
    $parcel$export(module.exports, "getPlacement", ()=>$3bdcead9d38aaa77$export$a9fe23cfa43a7b55);
    var $5uXOq = parcelRequire("5uXOq");
    const $3bdcead9d38aaa77$export$7080b3e976bc91ab = (eventName, handler, element, options)=>{
        const savedHandler = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            savedHandler.current = handler;
        }, [
            handler
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const eventListener = ()=>savedHandler.current && savedHandler.current();
            element && element.addEventListener(eventName, eventListener, options);
            return ()=>{
                element && element.removeEventListener(eventName, eventListener, options);
            };
        }, [
            eventName,
            element,
            options
        ]);
    };
    const $3bdcead9d38aaa77$export$30416a530a92ed77 = (initialfirst, initialSecond, callback)=>{
        const triggerRef = (0, $5uXOq.useRef)(initialfirst);
        const cardRef = (0, $5uXOq.useRef)(initialSecond);
        const timeoutId = (0, $5uXOq.useRef)(null);
        const setStateDelayed = ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(()=>{
                if (!triggerRef.current && !cardRef.current) callback();
            }, 400);
        };
        const setTriggerRef = ()=>{
            triggerRef.current = true;
            setStateDelayed();
        };
        const unsetTriggerRef = ()=>{
            triggerRef.current = false;
            setStateDelayed();
        };
        const setCardRef = ()=>{
            cardRef.current = true;
            setStateDelayed();
        };
        const unsetCardRef = ()=>{
            cardRef.current = false;
            setStateDelayed();
        };
        const getTimeoutId = ()=>timeoutId.current;
        return {
            setTriggerRef: setTriggerRef,
            setCardRef: setCardRef,
            unsetTriggerRef: unsetTriggerRef,
            unsetCardRef: unsetCardRef,
            getTimeoutId: getTimeoutId
        };
    };
    const $3bdcead9d38aaa77$export$a9fe23cfa43a7b55 = (referenceElement)=>{
        if (referenceElement && typeof referenceElement.id === 'string' && referenceElement.id.indexOf('issue_summary') > -1) return 'left-start';
        return 'top-start';
    };
});
parcelRegister("8L4jp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2145977bf6427e9b$export$2e2bcd8739ae039);
    var $9B86Q;
    var $2145977bf6427e9b$export$2e2bcd8739ae039 = (api)=>{
        (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
            name: 'jira/profilecard/bridge'
        }).then((bridge)=>{
            bridge(api);
        });
    };
});
const $03bf38ed90f474bb$export$a1455360a24a2234 = 'profileCardNextLegacyView';
parcelRegister("8cFNQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ca0aae989d69173$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $26CR2 = parcelRequire("26CR2");
    var $d4xRU;
    var $7HGHK;
    var $pa9q9;
    var $irubU;
    const $1ca0aae989d69173$export$6f67c636e2e30540 = ({ cloudId: cloudId, profileClient: profileClient, accountId: accountId, actions: actions, onProfileClick: onProfileClick })=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const onReportingLinesClick = onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : undefined;
        const profileCardProps = {
            userId: accountId,
            cloudId: cloudId,
            actions: (0, (0, parcelRequire("irubU")).isCustomerAccount)(accountId) ? [] : actions,
            resourceClient: profileClient,
            onReportingLinesClick: onReportingLinesClick
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $26CR2.default), {
            ...profileCardProps,
            addFlag: (flag)=>{
                const flagId = (0, (0, parcelRequire("7HGHK")).toFlagId)(flag.id);
                showFlag({
                    id: flagId,
                    render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
                            ...flag,
                            onDismissed: ()=>{
                                dismissFlag(flagId);
                            },
                            ...props
                        })
                });
            }
        });
    };
    const $1ca0aae989d69173$var$ProfileCardResourced = $1ca0aae989d69173$export$6f67c636e2e30540;
    var $1ca0aae989d69173$export$2e2bcd8739ae039 = $1ca0aae989d69173$var$ProfileCardResourced;
});
parcelRegister("d4xRU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61381db0e069bc03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            flagType: "info",
            ...props
        }));
    var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("irubU", function(module, exports) {
    $parcel$export(module.exports, "restResponseToUserData", ()=>$51c0350fa0c23877$export$66691b1affeb3bc5);
    $parcel$export(module.exports, "isCustomerAccount", ()=>$51c0350fa0c23877$export$67a41405362363f0);
    $parcel$export(module.exports, "getSpaActions", ()=>$51c0350fa0c23877$export$518f47d656cb4e1a);
    var $dXQf6;
    const $51c0350fa0c23877$export$66691b1affeb3bc5 = (userData)=>({
            avatarUrl: userData.avatarUrls['48x48'],
            email: userData.emailAddress,
            fullName: userData.displayName,
            isBot: false,
            isCurrentUser: false,
            status: userData.active ? 'active' : 'inactive',
            accountType: userData.accountType
        });
    const $51c0350fa0c23877$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
    const $51c0350fa0c23877$var$getSpaViewProfileAction = (intl, baseUrl, accountId, onPushAction, onActionCleanup)=>({
            label: intl && intl.formatMessage((0, (0, parcelRequire("dXQf6")).profileCardMessages).viewProfile),
            id: 'view-profile',
            callback: ()=>{
                onPushAction(`${baseUrl}/jira/people/${accountId}`);
                onActionCleanup && onActionCleanup();
            },
            link: `${baseUrl}/jira/people/${accountId}`,
            shouldRender: (data)=>data?.accountType !== 'customer'
        });
    const $51c0350fa0c23877$var$getAssignedIssuesAction = (intl, baseUrl, accountId)=>({
            label: intl && intl.formatMessage((0, (0, parcelRequire("dXQf6")).profileCardMessages).assignedIssues),
            id: 'assigned-issues',
            callback: ()=>{
                const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
                const url = `${baseUrl}/issues/?jql=${jql}`;
                window.open(url, '_blank');
            }
        });
    const $51c0350fa0c23877$var$getReportedIssuesAction = (intl, baseUrl, accountId)=>({
            label: intl && intl.formatMessage((0, (0, parcelRequire("dXQf6")).profileCardMessages).reportedIssues),
            id: 'reported-issues',
            callback: ()=>{
                const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
                const url = `${baseUrl}/issues/?jql=${jql}`;
                window.open(url, '_blank');
            }
        });
    const $51c0350fa0c23877$var$getViewFiltersAction = (intl, accountId)=>({
            label: intl && intl.formatMessage((0, (0, parcelRequire("dXQf6")).profileCardMessages).viewFilters),
            id: 'view-filters',
            callback: ()=>{
                const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
                window.open(url, '_blank');
            }
        });
    const $51c0350fa0c23877$export$518f47d656cb4e1a = (accountId, baseUrl, intl, onPushAction, actions, onActionCleanup)=>{
        if (actions) return actions.map((action)=>{
            switch(action){
                case 0, $e6a2e0952e4731b8$export$23cedd3261bd8015:
                    return $51c0350fa0c23877$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup);
                case 0, $e6a2e0952e4731b8$export$6bef782d14a92db8:
                    return $51c0350fa0c23877$var$getAssignedIssuesAction(intl, baseUrl, accountId);
                case 0, $e6a2e0952e4731b8$export$6b36f20db7a18a86:
                    return $51c0350fa0c23877$var$getReportedIssuesAction(intl, baseUrl, accountId);
                case 0, $e6a2e0952e4731b8$export$56da0dd0b0aa67b9:
                    return $51c0350fa0c23877$var$getViewFiltersAction(intl, accountId);
                default:
                    throw new Error('unexpected action');
            }
        });
        return [
            $51c0350fa0c23877$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup)
        ];
    };
});
parcelRegister("dXQf6", function(module, exports) {
    $parcel$export(module.exports, "profileCardMessages", ()=>$fc94a6d63ddcda43$export$49f2d2ccb123fddf);
    var $7VHMR;
    const $fc94a6d63ddcda43$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        view: {
            "id": "profilecard-next",
            "defaultMessage": "View profile"
        }
    });
    const $fc94a6d63ddcda43$export$49f2d2ccb123fddf = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        assignedIssues: {
            "id": "profilecard-next.assigned-issues",
            "defaultMessage": "Assigned issues"
        },
        viewProfile: {
            "id": "profilecard-next.view-profile",
            "defaultMessage": "View profile"
        },
        reportedIssues: {
            "id": "profilecard-next.reported-issues",
            "defaultMessage": "Reported issues"
        },
        viewFilters: {
            "id": "profilecard-next.view-filters",
            "defaultMessage": "View filters"
        }
    });
});
parcelRegister("7hILA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$997ec0a349311359$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2OMDV;
    var $koeKL;
    var $eaMwL;
    var $9OXo1;
    var $9l5Jv;
    const $997ec0a349311359$var$ProfileCardWrapper = (props)=>{
        const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError } = props;
        const teamCentralUrl = (0, (0, parcelRequire("eaMwL")).useTeamCentralUrl)();
        const teamCentralBaseUrl = (0, (0, parcelRequire("eaMwL")).useTeamCentralBaseUrl)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const renderProfileClientContainerWrapper = (0, $5uXOq.useCallback)((tenantContext)=>{
            if (tenantContext && tenantContext.atlassianAccountId) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9l5Jv")).ProfileClientContainer), {
                fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                baseUrl: tenantContext.baseUrl,
                profileClient: externalProfileClient || null,
                onLoadError: onLoadError,
                isGlobal: true,
                teamCentralUrl: teamCentralUrl,
                teamCentralBaseUrl: teamCentralBaseUrl,
                cloudId: cloudId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9l5Jv")).ProfileClientSubscriber), null, ({ profileClient: profileClient })=>children(tenantContext.atlassianAccountId, profileClient, tenantContext.cloudId, tenantContext.baseUrl)));
            return children('', null, '', '');
        }, [
            children,
            externalProfileClient,
            onLoadError,
            teamCentralBaseUrl,
            teamCentralUrl,
            cloudId
        ]);
        if (TenantContextSubscriberComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement(TenantContextSubscriberComponent, null, ({ tenantContext: tenantContext })=>renderProfileClientContainerWrapper(tenantContext));
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return renderProfileClientContainerWrapper(tenantContext);
    };
    $997ec0a349311359$var$ProfileCardWrapper.defaultProps = {
        externalProfileClient: null,
        sourceName: null,
        createAnalyticsEvent: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $997ec0a349311359$export$2e2bcd8739ae039 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)((0, $e6a2e0952e4731b8$export$3145fc6c544ad7bf), {
        onLoadError: (0, $e6a2e0952e4731b8$export$2549357601611c61)
    })($997ec0a349311359$var$ProfileCardWrapper);
});
parcelRegister("eaMwL", function(module, exports) {
    $parcel$export(module.exports, "useTeamCentralUrl", ()=>$e409b0391be08f30$export$12bf0987a96bab08);
    $parcel$export(module.exports, "useTeamCentralBaseUrl", ()=>$e409b0391be08f30$export$b49e0105c58cb761);
    var $2tT7R;
    const $e409b0391be08f30$export$12bf0987a96bab08 = ()=>'/gateway/api/watermelon/graphql';
    const $e409b0391be08f30$export$b49e0105c58cb761 = ()=>{
        const env = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        if (env === 'staging' || env === 'dev' || env === 'local') return 'https://team.stg.atlassian.com';
        return 'https://team.atlassian.com';
    };
});
parcelRegister("9l5Jv", function(module, exports) {
    $parcel$export(module.exports, "createUserProfileCardClient", ()=>$85b7b963f4e84597$export$c4393c51e6d104c3);
    $parcel$export(module.exports, "ProfileClientSubscriber", ()=>$85b7b963f4e84597$export$10cad281024d43c8);
    $parcel$export(module.exports, "useProfileClient", ()=>$85b7b963f4e84597$export$d43dc22a8337ee9f);
    $parcel$export(module.exports, "ProfileClientContainer", ()=>$85b7b963f4e84597$export$d816ba2709570028);
    parcelRequire("26CR2");
    var $bp5g1 = parcelRequire("bp5g1");
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $hAkh7;
    const $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
    const $85b7b963f4e84597$export$c4393c51e6d104c3 = (fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, gatewayGraphqlUrl, cloudId)=>{
        const userClient = new (0, (0, parcelRequire("hAkh7")).CustomProfileClient)(fabricPfDirUrl, baseUrl, onLoadError);
        return new (0, $bp5g1.default)({
            cacheMaxAge: 180000,
            cacheSize: 20,
            url: fabricPfDirUrl,
            teamCentralUrl: teamCentralUrl,
            teamCentralBaseUrl: teamCentralBaseUrl,
            productIdentifier: 'jira',
            gatewayGraphqlUrl: gatewayGraphqlUrl,
            cloudId: cloudId
        }, {
            userClient: userClient
        });
    };
    const $85b7b963f4e84597$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, baseUrl: baseUrl, profileClient: profileClient, onLoadError: onLoadError, teamCentralUrl: teamCentralUrl, teamCentralBaseUrl: teamCentralBaseUrl, cloudId: cloudId })=>{
            const finalProfileClient = profileClient || $85b7b963f4e84597$export$c4393c51e6d104c3(fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId);
            setState({
                profileClient: finalProfileClient
            });
        };
    const $85b7b963f4e84597$export$e324594224ef24da = {
        bootstrap: $85b7b963f4e84597$export$36aff1fbb4f5dfc6
    };
    const $85b7b963f4e84597$export$d4c72bab9d6cc13a = {
        profileClient: null
    };
    const $85b7b963f4e84597$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $85b7b963f4e84597$export$d4c72bab9d6cc13a,
        actions: $85b7b963f4e84597$export$e324594224ef24da
    });
    const $85b7b963f4e84597$export$10cad281024d43c8 = (0, (0, parcelRequire("51nlc")).createSubscriber)($85b7b963f4e84597$export$6f57813fe9f31bf9);
    const $85b7b963f4e84597$export$d43dc22a8337ee9f = (0, (0, parcelRequire("3sQ5x")).createHook)($85b7b963f4e84597$export$6f57813fe9f31bf9);
    const $85b7b963f4e84597$export$d816ba2709570028 = (0, (0, parcelRequire("gg7kZ")).createContainer)($85b7b963f4e84597$export$6f57813fe9f31bf9, {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($85b7b963f4e84597$export$e324594224ef24da.bootstrap())
    });
});
parcelRegister("hAkh7", function(module, exports) {
    $parcel$export(module.exports, "CustomProfileClient", ()=>$cb9e61605bbc1703$export$aa8db43941b8d3a7);
    parcelRequire("26CR2");
    var $dFLsP = parcelRequire("dFLsP");
    var $7f4tk;
    var $irubU;
    class $cb9e61605bbc1703$export$aa8db43941b8d3a7 extends (0, $dFLsP.default) {
        constructor(fabricPfDirUrl, baseUrl, onLoadError){
            super({
                url: fabricPfDirUrl,
                cacheSize: 20,
                cacheMaxAge: 180000
            });
            this.makeRequest = async (cloudId, userId)=>{
                try {
                    if ((0, (0, parcelRequire("irubU")).isCustomerAccount)(userId)) {
                        const response = await (0, (0, parcelRequire("7f4tk")).default)(`${this.baseUrl}/rest/api/3/user?accountId=${userId}`);
                        return (0, (0, parcelRequire("irubU")).restResponseToUserData)(response);
                    }
                    return await this.parentMakeRequest(cloudId, userId);
                } catch (err) {
                    const error = new Error(`Unable to fetch user: ${err.message}`, {
                        cause: err
                    });
                    this.onLoadError?.(err);
                    throw error;
                }
            };
            this.baseUrl = baseUrl;
            this.onLoadError = onLoadError;
            this.parentMakeRequest = super.makeRequest;
        }
    }
});
parcelRegister("kKeZ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65eeb7d31cebb7a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    parcelRequire("26CR2");
    var $264zF = parcelRequire("264zF");
    var $cSD7y;
    var $d4xRU;
    var $7HGHK;
    var $2OMDV;
    const $65eeb7d31cebb7a6$var$PEOPLE_PROFILE_PATH = '/people/';
    const $65eeb7d31cebb7a6$var$ProfileCardTriggerWithAnalyticsNew = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)((0, $aa25c26fa0ed8a05$export$a1455360a24a2234), {
        analytics: ''
    })((0, $264zF.default));
    class $65eeb7d31cebb7a6$var$ProfileCardView extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                position: 'top-start',
                trigger: 'hover'
            };
        }
        render() {
            const { children: children, position: position, trigger: trigger, accountId: accountId, cloudId: cloudId, profileClient: profileClient, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, viewingUserId: viewingUserId } = this.props;
            const ProfileCardComponent = $65eeb7d31cebb7a6$var$ProfileCardTriggerWithAnalyticsNew;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement($65eeb7d31cebb7a6$var$Wrapper, {
                ref: this.profileCardWrapperRef,
                onClick: (event)=>{
                    if (this.profileCardWrapperRef?.current !== null && !this.profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ProfileCardComponent, {
                cloudId: cloudId,
                userId: accountId,
                resourceClient: profileClient,
                position: position,
                trigger: trigger,
                testId: testId,
                actions: actions,
                reportingLinesProfileUrl: $65eeb7d31cebb7a6$var$PEOPLE_PROFILE_PATH,
                prepopulatedData: prepopulatedData,
                onReportingLinesClick: onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : null,
                addFlag: (flag)=>{
                    const flagId = (0, (0, parcelRequire("7HGHK")).toFlagId)(flag.id);
                    addFlag({
                        id: flagId,
                        render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
                                ...flag,
                                onDismissed: ()=>{
                                    dismissFlag(flagId);
                                },
                                ...props
                            })
                    });
                },
                viewingUserId: viewingUserId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)))));
        }
        constructor(...args){
            super(...args);
            this.profileCardWrapperRef = (0, $5uXOq.createRef)();
        }
    }
    var $65eeb7d31cebb7a6$export$2e2bcd8739ae039 = $65eeb7d31cebb7a6$var$ProfileCardView;
    const $65eeb7d31cebb7a6$var$WrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1osq _1l8r1osq",
                __cmplp.className
            ])
        });
    });
    const $65eeb7d31cebb7a6$var$WrapperNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1osq",
                __cmplp.className
            ])
        });
    });
    const $65eeb7d31cebb7a6$var$Wrapper = (0, (0, parcelRequire("cSD7y")).componentWithFG)('platform_profile_card_css_refactor', $65eeb7d31cebb7a6$var$WrapperNew, $65eeb7d31cebb7a6$var$WrapperOld);
    $65eeb7d31cebb7a6$var$Wrapper.displayName = 'Wrapper';
});
const $aa25c26fa0ed8a05$export$a1455360a24a2234 = 'profileCardNextView';
